<template>
  <div v-title :data-title="$route.name">
    <!-- style=" border-style: solid; border-width: 5px; border-color: transparent;" -->
    <div
      v-if="offsetwidth > 850"
      :key="'pc'"
      style="
        width: 100%;
        overflow: hidden;
        position: relative;
        min-width: 1349px;
        background-color: white !important;
      "
      class="home-pagepc"
    >
      <img
        style="width: 100%"
        src="../assets/Battertimg/PC/hometopone.jpg"
        alt=""
      />
      <!-- <div style="position: relative">
        <div style="width: 100%">
          <el-carousel
            :height="imgHeight"
            trigger="click"
            :interval="3000"
            :effect="'creative'"
            @change="handleSlideChange"
          >
            <el-carousel-item v-for="(item, index) in images" :key="index">
              <div
                class="creative-slide"
                :class="{ 'active-slide': currentIndex === index }"
              >
                <div style="position: relative">
                  <img
                    class="slide-image"
                    ref="imgHeight"
                    :src="item.idview"
                    alt="Nodata"
                    style="width: 100%"
                    @load="imgLoad"
                  />
                  <div
                    v-if="item.id === 1"
                    style="
                      position: absolute;
                      top: 52%;
                      left: 8%;
                      transform: translateY(-50%);
                      color: white;
                      text-align: left;
                      z-index: 10;
                    "
                  >
                    <div
                      style="
                        font-size: 48px;
                        font-weight: 800;
                        line-height: 1;
                        margin-bottom: 8px;
                        font-family: Cotyledon-Regular-bold;
                      "
                    >
                      Solar Energy
                    </div>
                    <div
                      style="
                        font-size: 48px;
                        font-weight: 800;
                        line-height: 1;
                        margin-bottom: 8px;
                        font-family: Cotyledon-Regular-bold;
                      "
                    >
                      Storage Battery
                    </div>
                  
                  </div>
                  <div
                    v-if="item.id === 3"
                    style="
                      position: absolute;
                      top: 52%;
                      left: 8%;
                      transform: translateY(-50%);
                      color: white;
                      text-align: left;
                      z-index: 10;
                    "
                  >
                    <div
                      style="
                        font-size: 48px;
                        font-weight: 800;
                        line-height: 1;
                        margin-bottom: 8px;
                        font-family: Cotyledon-Regular-bold;
                      "
                    >
                      Solar Energy
                    </div>
                    <div
                      style="
                        font-size: 48px;
                        font-weight: 800;
                        line-height: 1;
                        margin-bottom: 8px;
                        font-family: Cotyledon-Regular-bold;
                      "
                    >
                      Storage Battery
                    </div>
                  </div>
                </div>
                <div></div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      
      </div> -->
      <div class="revolution-section">
        <h2 class="section-title">
          Reliable Solar & Battery Solutions for Homes in Victoria
        </h2>
        <div class="description" style="margin-bottom: 30px">
          Power your home with clean,affordable energy using hight-quality solar
          and battery systems designed for Ausrtalian conditions.
        </div>
        <div class="stats-container">
          <div class="stat-item">
            <div class="stat-number">
              <img
                src="../assets/Battertimg/PC/duigou.png"
                style="height: 48px; margin-right: 10px"
                class="stat-numbeiconpc"
                alt=""
              />
              <div style="line-height: 2.5">Get a Free Quote</div>
            </div>
          </div>
          <div class="stat-item">
            <div class="stat-number">
              <img
                src="../assets/Battertimg/PC/phonehome.png"
                style="height: 48px; margin-right: 10px"
                class="stat-numbeiconpc"
                alt=""
              />
              <div style="line-height: 2.5">Call Now</div>
            </div>
          </div>
        </div>
      </div>

      <div
        :style="{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: carouselHeight,
        }"
        class="background-container"
      >
        <div
          class="transparent-carousel-container"
          style="width: 100%; height: 100%"
        >
          <!-- arrow="always" -->
          <el-carousel
            :height="carouselHeight"
            trigger="click"
            :interval="3000"
            :effect="'creative'"
            @change="handlechanpinSlideChange"
          >
            <el-carousel-item
              v-for="(item, index) in imagescopy"
              :key="index"
              @click.native="handleCarouselClick(item)"
              style="width: 100%; height: 100%"
            >
              <div
                class="creative-slide transparent"
                :class="{ 'active-slide': currentIndexcopy === index }"
                style="width: 100%; height: 100%"
              >
                <img
                  class="slide-image transparent-slide-image"
                  ref="imgHeightcopy"
                  :src="item.FilePath"
                  alt="Nodata"
                  style="
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    display: block;
                    cursor: pointer;
                  "
                  @load="imgLoadcopy"
                />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>

      <div
        style="width: 100%; height: auto; text-align: center; padding: 50px 0"
      >
        <div class="section-title">Product Gallery</div>
        <div class="centered-swiper-container">
          <swiper
            v-if="slides.length"
            ref="centeredSwiper"
            :options="computedSwiperOptions"
            @slideChange="onSlideChange"
            @click="handleSlideClick()"
            :loop="shouldEnableLoop"
          >
            <swiper-slide
              v-for="(slide, index) in slides"
              :key="slide.FileId || index"
              :class="['slide-item', { 'active-slide': isActive(index) }]"
            >
              <div class="slide-content">
                <!-- 图片类型 -->
                <img
                  v-if="slide.type === 'image'"
                  :src="slide.FilePath"
                  :alt="slide.FileName"
                  class="media-element"
                  @@click.stop="handleImageClick(slide, index)"
                />

                <!-- 视频类型 -->
                <div v-else-if="slide.type === 'video'" class="video-container">
                  <video
                    :ref="`video-${index}`"
                    :src="slide.FilePath"
                    :poster="slide.generatedPoster || slide.poster"
                    class="media-element"
                    @@click.stop="handleVideoClick(slide, index)"
                    @loadeddata="onVideoLoaded(index)"
                    preload="metadata"
                    crossorigin="anonymous"
                  ></video>

                  <!-- 视频加载指示器 -->
                  <div v-if="slide.loadingPoster" class="video-loading">
                    <div class="loading-spinner"></div>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>

          <!-- 加载状态 -->
          <div v-if="loading" class="loading-container">
            <div class="loading-spinner"></div>
            <p>Loading...</p>
          </div>

          <!-- 空状态 -->
          <div v-else-if="!slides.length" class="empty-container">
            <p>No Data</p>
          </div>

          <!-- 自定义分页器 -->
          <div v-if="slides.length" class="custom-pagination-container">
            <div
              v-for="(slide, index) in slides"
              :key="index"
              :class="[
                'custom-bullet',
                { 'active-bullet': currentActiveIndex === index },
              ]"
              @click="slideTo(index)"
            >
              <div class="bullet-inner"></div>
            </div>
          </div>
        </div>
      </div>

      <!--  Certifications obtained -->
      <div
        style="
          width: 100%;
          height: auto;
          text-align: center;
          padding: 50px 100px;
        "
        class="Certificationsbufen"
      >
        <div class="section-title">Certifications obtained</div>

        <!-- 添加容器限制宽度并居中 -->
        <div class="cert-container" id="click-scroll-X">
          <div class="icons-wrapper">
            <!-- 左箭头 -->
            <div
              class="left_btn"
              @click="scroll('left')"
              :style="{
                cursor: disableLeft ? 'not-allowed' : 'pointer',
              }"
            >
              <!-- opacity: disableLeft ? 0.5 : 1, -->
              <img
                src="../assets/Battertimg/PC/left.png"
                style="width: 30px; height: 30px"
                alt="left"
              />
            </div>
            <!-- <i
              class="left_btn el-icon-arrow-left"
              @click="scroll('left')"
              :style="{
                cursor: disableLeft ? 'not-allowed' : 'pointer',
                opacity: disableLeft ? 0.5 : 1,
              }"
            ></i> -->
            <!-- <i class="left_btn el-icon-arrow-left" @click="scroll('left')"></i> -->
            <!-- <button class="arrow left" @click="scroll('left')">‹</button> -->

            <!-- 图标滚动区域 -->
            <div class="icons-track" ref="track">
              <div
                class="icons-list"
                :style="{ transform: `translateX(${offset}px)` }"
              >
                <a
                  v-for="(cert, index) in certifications"
                  :key="index"
                  class="cert-icon"
                  :href="cert.link"
                  target="_blank"
                >
                  <img :src="cert.icon" />
                </a>
              </div>
            </div>

            <!-- 右箭头 -->
            <!-- <button class="arrow right" @click="scroll('right')">›</button> -->
            <!-- <img src="../assets/Battertimg/PC/left.png" /> -->
            <!-- 右箭头 - 替换为图片 -->
            <div
              class="right_btn"
              @click="scroll('right')"
              :style="{
                cursor: disableRight ? 'not-allowed' : 'pointer',
              }"
            >
              <!-- opacity: disableRight ? 0.5 : 1, -->

              <img
                src="../assets/Battertimg/PC/right.png"
                style="width: 30px; height: 30px"
                alt="right"
              />
            </div>
            <!-- <i
              class="right_btn el-icon-arrow-right"
              @click="scroll('right')"
              :style="{
                cursor: disableRight ? 'not-allowed' : 'pointer',
                opacity: disableRight ? 0.5 : 1,
              }"
            ></i> -->
            <!-- <i
              class="right_btn el-icon-arrow-right"
              @click="scroll('right')"
            ></i> -->
          </div>
        </div>
      </div>

      <!-- Process 部分 -->
      <div
        style="
          width: 100%;
          height: auto;
          text-align: center;
          padding: 50px 20px;
        "
        class="Processbufen"
      >
        <div class="section-title">Our Simple Processes</div>

        <div class="process-container">
          <div class="process-steps">
            <div
              class="process-step"
              :class="{ active: activeStep === 1 }"
              @mouseover="setHover(1)"
              @mouseleave="clearHover"
              @click="setActive(1)"
            >
              <div class="step-icon-wrapper">
                <img
                  :src="
                    activeStep === 1 || hoverStep === 1
                      ? step1HoverIcon
                      : step1Icon
                  "
                  class="step-icon"
                  alt="预约图标"
                />
              </div>
              <div class="step-title">1.Free Consultation</div>
            </div>

            <div class="step-connector"></div>

            <div
              class="process-step"
              :class="{ active: activeStep === 2 }"
              @mouseover="setHover(2)"
              @mouseleave="clearHover"
              @click="setActive(2)"
            >
              <div class="step-icon-wrapper">
                <img
                  :src="
                    activeStep === 2 || hoverStep === 2
                      ? step2HoverIcon
                      : step2Icon
                  "
                  class="step-icon"
                  alt="报价图标"
                />
              </div>
              <div class="step-description">2.Home Energy <br />Assessment</div>
            </div>

            <div class="step-connector"></div>

            <div
              class="process-step"
              :class="{ active: activeStep === 3 }"
              @mouseover="setHover(3)"
              @mouseleave="clearHover"
              @click="setActive(3)"
            >
              <div class="step-icon-wrapper">
                <img
                  :src="
                    activeStep === 3 || hoverStep === 3
                      ? step3HoverIcon
                      : step3Icon
                  "
                  class="step-icon"
                  alt="安装图标"
                />
              </div>
              <div class="step-title">3.Custom System<br />Design</div>
            </div>

            <div class="step-connector"></div>

            <div
              class="process-step"
              :class="{ active: activeStep === 4 }"
              @mouseover="setHover(4)"
              @mouseleave="clearHover"
              @click="setActive(4)"
            >
              <div class="step-icon-wrapper">
                <img
                  :src="
                    activeStep === 4 || hoverStep === 4
                      ? step4HoverIcon
                      : step4Icon
                  "
                  class="step-icon"
                  alt="省钱图标"
                />
              </div>
              <div class="step-title">4.Professional<br />Installation</div>
            </div>
            <div class="step-connector"></div>
            <div
              class="process-step"
              :class="{ active: activeStep === 5 }"
              @mouseover="setHover(5)"
              @mouseleave="clearHover"
              @click="setActive(5)"
            >
              <div class="step-icon-wrapper">
                <img
                  :src="
                    activeStep === 5 || hoverStep === 5
                      ? step5HoverIcon
                      : step5Icon
                  "
                  class="step-icon"
                  alt="省钱图标"
                />
              </div>
              <div class="step-title">
                5.System Testing &<br />Safety Checks
              </div>
            </div>
            <div class="step-connector"></div>
            <div
              class="process-step"
              :class="{ active: activeStep === 6 }"
              @mouseover="setHover(6)"
              @mouseleave="clearHover"
              @click="setActive(6)"
            >
              <div class="step-icon-wrapper">
                <img
                  :src="
                    activeStep === 6 || hoverStep === 6
                      ? step6HoverIcon
                      : step6Icon
                  "
                  class="step-icon"
                  alt="省钱图标"
                />
              </div>
              <div class="step-title">6.Customer<br />Handover & Support</div>
            </div>
          </div>
        </div>
      </div>
      <div
        style="
          background-color: #eeeeee !important;
          text-align: center;
          width: 100%;
          padding-top: 20px;
          padding-bottom: 35px;
        "
      >
        <div class="Safetytitle">Safety & Quality You Can Trust</div>
        <div
          style="
            text-align: left;
            width: 572px;
            margin: auto;
            color: #666666 !important;
          "
        >
          <div class="Safetyneirong" style="margin-top: 30px">
            Your safety is our highest priority, Every residential system we
            supply and install complies with:
          </div>
          <div class="Safetyneirong">• Australian Electrical Standards</div>
          <div class="Safetyneirong">• Battery Safety Standard AS/Nzs 5139</div>
          <div class="Safetyneirong">• Wiring Rules AS/NZS 3000</div>
          <div class="Safetyneirong">• Grid Connection Standards</div>
          <div class="Safetyneirong">
            All work is carried out by qualified professionals.
          </div>
        </div>
      </div>
      <!-- 底部导航 -->
      <footer class="header-navbar">
        <!-- 第一行：LOGO和导航项 -->
        <div class="top-nav" style="height: 28px !important">
          <div class="logo-container">
            <div class="logo">
              <img
                style="height: 28px !important"
                src="../assets/Battertimg/PC/Batteryplantlogo.png"
                alt=""
              />
            </div>
          </div>

          <div class="nav-items">
            <div class="nav-item" @click="goto('HOME')">HOME</div>
            <div class="nav-item" @click="goto('PROJECT')">ABOUT US</div>
            <div class="nav-item" @click="goto('PRODUCTS')">PRODUCTS</div>
            <div class="nav-item" @click="goto('CASE')">GALLERY</div>
            <div class="nav-item" @click="goto('CONTACTUS')">CONTACT US</div>
            <div class="nav-item" @click="goto('CONTACTUS')">BOOK NOW</div>
          </div>
        </div>
        <div
          style="
            height: 1px;
            background-color: #cccccc;
            margin-top: 15px;
            margin-bottom: 18px;
          "
        ></div>
        <!-- 间距30px后的邮件信息 -->
        <div>
          <div class="email-content">(04) 5245 7579</div>
          <div class="email-content">info@batteryplant.com.au</div>
          <div class="email-content">
            203 Blackburn Rd Mount Waverley VIC 3149
          </div>
        </div>
      </footer>
    </div>
    <div
      v-else
      :key="'mobile'"
      style="
        width: 100%;
        border: 1px solid #f8f9fa;
        overflow: hidden;
        position: relative;
        background-color: white !important;
      "
      class="home-pageh5"
    >
      <img
        style="width: 100%"
        src="../assets/Battertimg/H5/hometopone.jpg"
        alt=""
      />
      <!-- <div style="position: relative">
        <div style="width: 100%">
          <el-carousel
            :height="imgHeight"
            trigger="click"
            :interval="3000"
            :effect="'creative'"
            @change="handleSlideChange"
          >
            <el-carousel-item v-for="(item, index) in imagesh5" :key="index">
              <div
                class="creative-slide"
                :class="{ 'active-slide': currentIndex === index }"
              >
                <div style="position: relative">
                  <img
                    class="slide-image"
                    ref="imgHeight"
                    :src="item.idview"
                    alt="Nodata"
                    style="width: 100%"
                    @load="imgLoad"
                  />
                  <div
                    v-if="item.id === 1"
                    style="
                      position: absolute;
                      top: 38%;
                      left: 8%;
                      transform: translateY(-50%);
                      color: white;
                      text-align: left;
                      z-index: 10;
                    "
                  >
                    <div
                      style="
                        font-size: 28px;
                        font-family: Cotyledon-Regular-bold;
                        line-height: 1;
                        margin-bottom: 8px;
                      "
                    >
                      Solar Energy
                    </div>
                    <div
                      style="
                        font-size: 28px;
                        font-family: Cotyledon-Regular-bold;
                        line-height: 1;
                        margin-bottom: 8px;
                      "
                    >
                      Storage Battery
                    </div>
                  
                  </div>
                  <div
                    v-if="item.id === 3"
                    style="
                      position: absolute;
                      top: 38%;
                      left: 8%;
                      transform: translateY(-50%);
                      color: white;
                      text-align: left;
                      z-index: 10;
                    "
                  >
                    <div
                      style="
                        font-size: 28px;
                        font-family: Cotyledon-Regular-bold;
                        line-height: 1;
                        margin-bottom: 8px;
                      "
                    >
                      Solar Energy
                    </div>
                    <div
                      style="
                        font-size: 28px;
                        font-family: Cotyledon-Regular-bold;
                        line-height: 1;
                        margin-bottom: 8px;
                      "
                    >
                      Storage Battery
                    </div>
                  </div>
                </div>
                <div></div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
  
      </div> -->

      <div class="mobile-revolution-section">
        <h2 class="biaotititle" style="line-height: 1.3">
          Reliable Solar & Battery Solutions <br />for Homes in Victoria
        </h2>
        <div class="description">
          Power your home with clean,affordable energy using hight-quality solar
          and battery systems designed for Ausrtalian conditions.
        </div>
        <!-- 修改后的统计项容器 - 两列三行布局 -->
        <!-- 修改移动端统计项布局 -->
        <div class="mobile-stats-container-wrapper">
          <div class="mobile-stats-container">
            <div class="stat-item">
              <div class="stat-number">
                <img
                  style="margin-left: 5px"
                  src="../assets/Battertimg/PC/duigou.png"
                  class="mobliestatnumbericon"
                  alt=""
                />
                <div class="stat-text" style="margin-left: 10px">
                  Get a Free Quote
                </div>
              </div>
            </div>
            <div class="stat-item">
              <div class="stat-number">
                <img
                  style="margin-left: 5px"
                  src="../assets/Battertimg/PC/phonehome.png"
                  class="mobliestatnumbericon"
                  alt=""
                />
                <div class="stat-text" style="margin-left: 10px">Call Now</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        :style="{
          backgroundImage: `url(${backgroundImageh5})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: imgHeightcopy || '400px' /* 使用轮播图高度，默认300px */,
        }"
        class="responsive-container"
      >
        <div style="width: 100%">
          <!-- arrow="always" -->
          <el-carousel
            :height="imgHeightcopy || '400px'"
            trigger="click"
            :interval="3000"
            :effect="'creative'"
            @change="handlechanpinSlideChange"
          >
            <el-carousel-item
              v-for="(item, index) in imagescopyh5"
              :key="index"
              @click.native="handleCarouselClick(item)"
            >
              <div
                class="creative-slide"
                :class="{ 'active-slide': currentIndexcopy === index }"
              >
                <img
                  class="slide-image"
                  ref="imgHeightcopy"
                  :src="item.FilePath"
                  alt="Nodata"
                  style="width: 100%; display: block"
                  @load="imgLoadcopy"
                />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div
        style="width: 100%; height: auto; text-align: center; padding: 30px 0"
      >
        <div class="biaotititle">Product Gallery</div>
        <div class="centered-swiper-container">
          <swiper
            v-if="slides.length"
            ref="centeredSwiper"
            :options="computedSwiperOptionsH5"
            @slideChange="onSlideChange"
            @click="handleSlideClick()"
            :loop="shouldEnableLoop"
          >
            <swiper-slide
              v-for="(slide, index) in slides"
              :key="slide.FileId || index"
              :class="['slide-item', { 'active-slide': isActive(index) }]"
            >
              <div class="slide-content">
                <!-- 图片类型 -->
                <img
                  v-if="slide.type === 'image'"
                  :src="slide.FilePath"
                  :alt="slide.FileName"
                  class="media-element"
                  @click="handleImageClick(slide, index)"
                />

                <!-- 视频类型 -->
                <div v-else-if="slide.type === 'video'" class="video-container">
                  <video
                    :ref="`video-${index}`"
                    :src="slide.FilePath"
                    :poster="slide.generatedPoster || slide.poster"
                    class="media-element"
                    @click="handleVideoClick(slide, index)"
                    @loadeddata="onVideoLoaded(index)"
                    preload="metadata"
                    crossorigin="anonymous"
                  ></video>

                  <!-- 视频加载指示器 -->
                  <div v-if="slide.loadingPoster" class="video-loading">
                    <div class="loading-spinner"></div>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>

          <!-- 加载状态 -->
          <div v-if="loading" class="loading-container">
            <div class="loading-spinner"></div>
            <p>Loading...</p>
          </div>

          <!-- 空状态 -->
          <div v-else-if="!slides.length" class="empty-container">
            <p>No Data</p>
          </div>

          <!-- 自定义分页器 -->
          <div v-if="slides.length" class="custom-pagination-container">
            <div
              v-for="(slide, index) in slides"
              :key="index"
              :class="[
                'custom-bullet',
                { 'active-bullet': currentActiveIndex === index },
              ]"
              @click="slideTo(index)"
            >
              <div class="bullet-inner"></div>
            </div>
          </div>
        </div>
      </div>

      <!--  Certifications obtained -->
      <div
        style="width: 100%; height: auto; text-align: center; padding: 30px 0"
      >
        <div class="biaotititle">Certifications obtained</div>
        <!-- 修改移动端证书容器部分 -->
        <div class="cert-container" id="click-scroll-X">
          <div
            class="icons-wrapper"
            :class="{ 'mobile-layout': offsetwidth <= 850 }"
          >
            <!-- 左箭头 -->
            <!-- <i
              class="left_btn el-icon-arrow-left"
              @click="scroll('left')"
              :style="{
                cursor: disableLeft ? 'not-allowed' : 'pointer',
                opacity: disableLeft ? 0.5 : 1,
              }"
            ></i> -->
            <div
              class="left_btn"
              @click="scroll('left')"
              :style="{
                cursor: disableLeft ? 'not-allowed' : 'pointer',
              }"
            >
              <!-- opacity: disableLeft ? 0.5 : 1, -->
              <img
                src="../assets/Battertimg/PC/left.png"
                style="width: 30px; height: 30px"
                alt="left"
              />
            </div>
            <!-- 图标滚动区域 -->
            <div class="icons-track" ref="track">
              <div
                class="icons-list"
                :style="{ transform: `translateX(${offset}px)` }"
              >
                <a
                  v-for="(cert, index) in certifications"
                  :key="index"
                  class="cert-icon"
                  :href="cert.link"
                  target="_blank"
                >
                  <img :src="cert.icon" />
                </a>
              </div>
            </div>
            <div
              class="right_btn"
              @click="scroll('right')"
              :style="{
                cursor: disableRight ? 'not-allowed' : 'pointer',
              }"
            >
              <!-- opacity: disableRight ? 0.5 : 1, -->

              <img
                src="../assets/Battertimg/PC/right.png"
                style="width: 30px; height: 30px"
                alt="right"
              />
            </div>
            <!-- 右箭头 -->
            <!-- <i
              class="right_btn el-icon-arrow-right"
              @click="scroll('right')"
              :style="{
                cursor: disableRight ? 'not-allowed' : 'pointer',
                opacity: disableRight ? 0.5 : 1,
              }"
            ></i> -->
          </div>
        </div>
      </div>
      <div
        style="width: 100%; height: auto; text-align: center; padding: 30px 0"
      >
        <div class="biaotititle">Our Simple Processes</div>

        <!-- 移动端两列排列的步骤流程图 -->
        <div class="mobile-process-container">
          <div class="mobile-process-grid">
            <!-- 第一行：步骤1和步骤2 -->
            <div class="mobile-process-row">
              <!-- 步骤 1 -->
              <div
                class="mobile-process-step"
                :class="{ 'mobile-active': activeStep === 1 }"
                @click="setActive(1)"
              >
                <div class="mobile-step-icon-wrapper">
                  <img
                    :src="activeStep === 1 ? step1HoverIcon : step1Icon"
                    class="mobile-step-icon"
                    alt="预约图标"
                  />
                </div>
                <div class="mobile-step-content">
                  <div
                    class="mobile-step-title"
                    :class="{ 'mobile-active-text': activeStep === 1 }"
                  >
                    1.Free Consultation
                  </div>
                </div>
              </div>

              <!-- 步骤 2 -->
              <div
                class="mobile-process-step"
                :class="{ 'mobile-active': activeStep === 2 }"
                @click="setActive(2)"
              >
                <div class="mobile-step-icon-wrapper">
                  <img
                    :src="activeStep === 2 ? step2HoverIcon : step2Icon"
                    class="mobile-step-icon"
                    alt="报价图标"
                  />
                </div>
                <div class="mobile-step-content">
                  <div
                    class="mobile-step-title"
                    :class="{ 'mobile-active-text': activeStep === 2 }"
                  >
                    2.Home Energy <br />Assessment
                  </div>
                </div>
              </div>
            </div>

            <!-- 第二行：步骤3和步骤4 -->
            <div class="mobile-process-row">
              <!-- 步骤 3 -->
              <div
                class="mobile-process-step"
                :class="{ 'mobile-active': activeStep === 3 }"
                @click="setActive(3)"
              >
                <div class="mobile-step-icon-wrapper">
                  <img
                    :src="activeStep === 3 ? step3HoverIcon : step3Icon"
                    class="mobile-step-icon"
                    alt="安装图标"
                  />
                </div>
                <div class="mobile-step-content">
                  <div
                    class="mobile-step-title"
                    :class="{ 'mobile-active-text': activeStep === 3 }"
                  >
                    3.Custom System<br />Design
                  </div>
                </div>
              </div>

              <!-- 步骤 4 -->
              <div
                class="mobile-process-step"
                :class="{ 'mobile-active': activeStep === 4 }"
                @click="setActive(4)"
              >
                <div class="mobile-step-icon-wrapper">
                  <img
                    :src="activeStep === 4 ? step4HoverIcon : step4Icon"
                    class="mobile-step-icon"
                    alt="省钱图标"
                  />
                </div>
                <div class="mobile-step-content">
                  <div
                    class="mobile-step-title"
                    :class="{ 'mobile-active-text': activeStep === 4 }"
                  >
                    4.Professional<br />Installation
                  </div>
                </div>
              </div>
            </div>

            <div class="mobile-process-row">
              <div
                class="mobile-process-step"
                :class="{ 'mobile-active': activeStep === 5 }"
                @click="setActive(5)"
              >
                <div class="mobile-step-icon-wrapper">
                  <img
                    :src="activeStep === 5 ? step5HoverIcon : step5Icon"
                    class="mobile-step-icon"
                    alt="省钱图标"
                  />
                </div>
                <div class="mobile-step-content">
                  <div
                    class="mobile-step-title"
                    :class="{ 'mobile-active-text': activeStep === 5 }"
                  >
                    5.System Testing &<br />Safety Checks
                  </div>
                </div>
              </div>
              <div
                class="mobile-process-step"
                :class="{ 'mobile-active': activeStep === 6 }"
                @click="setActive(6)"
              >
                <div class="mobile-step-icon-wrapper">
                  <img
                    :src="activeStep === 6 ? step6HoverIcon : step6Icon"
                    class="mobile-step-icon"
                    alt="省钱图标"
                  />
                </div>
                <div class="mobile-step-content">
                  <div
                    class="mobile-step-title"
                    :class="{ 'mobile-active-text': activeStep === 6 }"
                  >
                    6.Customer<br />Handover & Support
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style="
          background-color: #eeeeee !important;
          text-align: center;
          width: 100%;
          padding-top: 20px;
          padding-bottom: 35px;
        "
      >
        <div class="Safetytitleh5">Safety & Quality You Can Trust</div>
        <div
          style="
            text-align: left;
            width: 100%;
            margin: auto;
            color: #666 !important;
          "
        >
          <div class="Safetyneirongh5" style="margin-top: 30px !important">
            Your safety is our highest priority, Every residential system we
            supply and install complies with:
          </div>
          <div class="Safetyneirongh5">• Australian Electrical Standards</div>
          <div class="Safetyneirongh5">
            • Battery Safety Standard AS/Nzs 5139
          </div>
          <div class="Safetyneirongh5">• Wiring Rules AS/NZS 3000</div>
          <div class="Safetyneirongh5">• Grid Connection Standards</div>
          <div class="Safetyneirongh5">
            All work is carried out by qualified professionals.
          </div>
        </div>
      </div>
      <!-- 底部导航 -->
      <!-- 在移动端部分（v-else内）修改底部导航栏 -->
      <footer class="mobile-footer-navbar">
        <!-- 垂直排列的容器 -->
        <div class="vertical-container">
          <!-- LOGO区域 -->
          <div class="logo-section">
            <div class="logo-container">
              <div class="logo">
                <img
                  style="height: 28px !important"
                  src="../assets/Battertimg/PC/Batteryplantlogo.png"
                  alt="Battery Plant Logo"
                />
              </div>
            </div>
          </div>

          <!-- 导航项区域（手动编写每个项） -->
          <div class="nav-section">
            <div
              class="nav-item"
              :class="{ active: activeNav === 0 }"
              @click="
                activateNav(0);
                goto('HOME');
              "
            >
              HOME
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 1 }"
              @click="
                activateNav(1);
                goto('PROJECT');
              "
            >
              ABOUT US
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 2 }"
              @click="
                activateNav(2);
                goto('PRODUCTS');
              "
            >
              PRODUCTS
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 3 }"
              @click="
                activateNav(3);
                goto('CASE');
              "
            >
              GALLERY
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 4 }"
              @click="
                activateNav(4);
                goto('CONTACTUS');
              "
            >
              CONTACT US
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 5 }"
              @click="
                activateNav(5);
                goto('CONTACTUS');
              "
            >
              BOOK NOW
            </div>
          </div>
          <div style="height: 1px; background-color: #cccccc"></div>
          <!-- 邮件信息区域 -->
          <div class="contact-section">
            <div class="email-contentmobile">(04) 5245 7579</div>
            <div class="email-contentmobile">info@batteryplant.com.au</div>
            <div class="email-contentmobile">
              203 Blackburn Rd Mount Waverley VIC 3149
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
import { get, post } from "../assets/api/api";
import { HomePageProductCarouselDisplay } from "../assets/api/request.js";
// 引入Swiper相关模块
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  name: "CaseSwiper",
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  props: {
    offsetwidth: {
      type: Number,
    },
  },
  data() {
    return {
      isLoopEnabled: true, // 是否启用循环模式
      dynamicSwiperOptions: null, // 动态配置
      dynamicSwiperOptionsH5: null, // H5动态配置
      imgHeightlunbo: "",
      loading: false,
      // 每组显示的图标数量（根据屏幕尺寸动态调整）
      // groupSize: 8,
      // 最小滚动步长（确保总是完整滚动一组）
      minGroupStep: 1,
      activeNav: null, // 跟踪当前激活的导航项
      backgroundImageh5: require("../assets/Battertimg/H5/homelunbobeijing.png"),
      backgroundImage: require("../assets/Battertimg/PC/chanpinlunbobeijing.jpg"),
      // Process 相关数据
      activeStep: 0,
      hoverStep: null,

      // 步骤图标 - 普通状态
      step1Icon: require("../assets/Battertimg/PC/zixun.png"),
      step2Icon: require("../assets/Battertimg/PC/yusuan.png"),
      step3Icon: require("../assets/Battertimg/PC/celiang.png"),
      step4Icon: require("../assets/Battertimg/PC/anzhuang.png"),
      step5Icon: require("../assets/Battertimg/PC/jiancha.png"),
      step6Icon: require("../assets/Battertimg/PC/jiaoshou.png"),

      // 步骤图标 - 悬停/激活状态
      step1HoverIcon: require("../assets/Battertimg/PC/zixunlv.png"),
      step2HoverIcon: require("../assets/Battertimg/PC/yusuanlv.png"),
      step3HoverIcon: require("../assets/Battertimg/PC/celianglv.png"),
      step4HoverIcon: require("../assets/Battertimg/PC/anzhuanglv.png"),
      step5HoverIcon: require("../assets/Battertimg/PC/jianchalv.png"),
      step6HoverIcon: require("../assets/Battertimg/PC/jiaoshoulv.png"),
      currentIndex: 0,
      currentIndexcopy: 0,
      hoverIndex: -1,
      activeIndex: -1,
      currentActiveIndex: 0,
      swiperInstance: null,
      // 混合图片和视频的幻灯片数据
      slides: [],
      swiperOptions: {
        // 添加自动轮播配置
        autoplay: {
          delay: 3000, // 3秒自动轮播
          disableOnInteraction: false,
        },
        slidesPerView: "auto",
        spaceBetween: 46,
        centeredSlides: true,
        centeredSlidesBounds: true,
        loop: true,
        loopAdditionalSlides: 10,
        loopFix: true,
        resistance: true,
        resistanceRatio: 0.98,
        iOSEdgeSwipeDetection: true,
        touchEventsTarget: "container",
        touchAngle: 45,
        threshold: 10,
        slideToClickedSlide: true,
        on: {
          init: function () {
            this.loopCreate();
            this.update();
            setTimeout(() => {
              this.loopDestroy();
              this.loopCreate();
              this.update();
            }, 100);
          },
          slideChange: function () {
            const safeIndex = Math.min(
              this.slides.length - 4,
              Math.max(0, this.realIndex)
            );
            if (this.realIndex >= this.slides.length - 3) {
              this.slideTo(safeIndex);
            }
          },
          reachEnd: function () {
            this.slideTo(this.slides.length - 4);
          },
          touchStart: function () {
            this.allowTouchMove = true;
          },
        },
        breakpoints: {
          1024: {
            slidesPerView: "auto",
            spaceBetween: 46,
          },
          768: {
            slidesPerView: "auto",
            spaceBetween: 10,
          },
          480: {
            slidesPerView: "auto",
            spaceBetween: 4,
          },
        },
      },
      swiperOptionsh5: {
        // 添加自动轮播配置
        autoplay: {
          delay: 3000, // 3秒自动轮播
          disableOnInteraction: false,
        },
        slidesPerView: "auto",
        spaceBetween: 15,
        centeredSlides: true,
        centeredSlidesBounds: true,
        loop: true,
        loopAdditionalSlides: 10,
        loopFix: true,
        resistance: true,
        resistanceRatio: 0.98,
        iOSEdgeSwipeDetection: true,
        touchEventsTarget: "container",
        touchAngle: 45,
        threshold: 10,
        slideToClickedSlide: true,
        on: {
          init: function () {
            this.loopCreate();
            this.update();
            setTimeout(() => {
              this.loopDestroy();
              this.loopCreate();
              this.update();
            }, 100);
          },
          slideChange: function () {
            const safeIndex = Math.min(
              this.slides.length - 4,
              Math.max(0, this.realIndex)
            );
            if (this.realIndex >= this.slides.length - 3) {
              this.slideTo(safeIndex);
            }
          },
          reachEnd: function () {
            this.slideTo(this.slides.length - 4);
          },
          touchStart: function () {
            this.allowTouchMove = true;
          },
        },
        breakpoints: {
          1024: {
            slidesPerView: "auto",
            spaceBetween: 15,
          },
          768: {
            slidesPerView: "auto",
            spaceBetween: 10,
          },
          480: {
            slidesPerView: "auto",
            spaceBetween: 4,
          },
        },
      },
      offset: 0,
      itemWidth: 100, // 调整为更合理的宽度
      visibleCount: 8,
      disableLeft: true, // 改为 data 属性
      disableRight: false, // 改为 data 属性
      certifications: [
        { icon: require("../assets/Battertimg/PC/jaslogo.png"), link: "#" },
        { icon: require("../assets/Battertimg/PC/saalogo.png"), link: "#" },
        { icon: require("../assets/Battertimg/PC/solarlogo.png"), link: "#" },
        {
          icon: require("../assets/Battertimg/PC/Approvedlogo.png"),
          link: "#",
        },
        // {
        //   icon: require("../assets/Battertimg/PC/victorialogo.png"),
        //   link: "#",
        // },
        { icon: require("../assets/Battertimg/PC/gcclogo.png"), link: "#" },
        { icon: require("../assets/Battertimg/PC/ILAClogo.png"), link: "#" },
        {
          icon: require("../assets/Battertimg/PC/Governmentlogo.png"),
          link: "#",
        },
        { icon: require("../assets/Battertimg/PC/SGSlogo.png"), link: "#" },
        // {
        //   icon: require("../assets/Battertimg/PC/solarvictorialogo.png"),
        //   link: "#",
        // },
      ],
      imgHeight: "",
      imgHeightcopy: "",
      imagesh5: [
        // {
        //   idview: require("../assets/Battertimg/H5/homeluntopnew1.jpg"),
        //   id: 1,
        // },
        {
          idview: require("../assets/Battertimg/H5/homelunbotopnew2.jpg"),
          id: 3,
        },
      ],
      images: [
        // {
        //   idview: require("../assets/Battertimg/PC/homttopone.jpg"),
        //   id: 1,
        // },
        // { idview: require("../assets/Battertimg/PC/hometop2.jpg"), id: 2 },
        { idview: require("../assets/Battertimg/PC/hometop3.jpg"), id: 3 },
      ],
      imagescopy: [
        {
          idview: require("../assets/Battertimg/PC/lunbochanpintouming.png"),
        },
        {
          idview: require("../assets/Battertimg/PC/lunbochanpintouming.png"),
        },
      ],
      imagescopyh5: [
        {
          idview: require("../assets/Battertimg/H5/首页H5产品轮播图1.png"),
        },
        {
          idview: require("../assets/Battertimg/H5/首页H5产品轮播图1.png"),
        },
      ],
    };
  },
  created() {
    this.getHomePageProductCarouselDisplay();
  },
  mounted() {
    document.documentElement.scrollTop = 0;
    // 为所有视频生成封面
    this.generateAllVideoPosters().then(() => {
      this.$nextTick(this.initSwiper);
    });
    this.imgLoad();
    this.imgLoadcopy();
    // 初始化证书滚动
    this.initCertScroll();
    this.updateBackgroundHeight();
    window.addEventListener("resize", this.updateBackgroundHeight);
    window.addEventListener("resize", this.onResize);
    window.onresize = () => {
      this.imgLoad();
      this.imgLoadcopy();
      this.initCertScroll(); // 窗口大小变化时重新初始化
    };
  },
  computed: {
    // 动态生成PC端Swiper配置
    computedSwiperOptions() {
      return this.dynamicSwiperOptions || this.swiperOptions;
    },

    // 动态生成移动端Swiper配置
    computedSwiperOptionsH5() {
      return this.dynamicSwiperOptionsH5 || this.swiperOptionsh5;
    },

    // 判断是否需要启用循环模式
    shouldEnableLoop() {
      return this.slides.length > 3; // 只有当幻灯片数量大于3时才启用循环
    },
    // 计算轮播图高度
    carouselHeight() {
      if (this.offsetwidth > 850) {
        // PC端：根据窗口宽度按比例计算高度
        const screenWidth = window.innerWidth;
        // 1920:960 = 2:1 的比例
        return Math.floor(screenWidth * 0.5) + "px";
      } else {
        // 移动端：保持原有逻辑或按移动端比例调整
        const screenWidth = window.innerWidth;
        return Math.floor(screenWidth * 0.5) + "px";
      }
    },
    dynamicHeight() {
      return (width) => width / 2; // 2:1宽高比
    },
    // 计算连接线宽度
    lineWidth() {
      const stepCount = this.steps.length - 1;
      return 100 / stepCount + "%";
    },

    maxOffset() {
      if (!this.$refs.track) return 0;
      const trackWidth = this.$refs.track.offsetWidth;
      const listWidth = this.certifications.length * this.itemWidth;
      return Math.min(0, trackWidth - listWidth);
    },
    //  disableLeft() {
    //     return this.offset >= 0;
    //   },
    //   disableRight() {
    //     if (!this.$refs.track) return false;
    //     const trackWidth = this.$refs.track.offsetWidth;
    //     const listWidth = this.certifications.length * this.itemWidth;
    //     return this.offset <= -(listWidth - trackWidth);
    //   },
    groupSize() {
      if (this.offsetwidth <= 850) {
        return 5; // 移动端固定显示5个
      } else {
        // PC端根据屏幕尺寸动态调整
        if (window.innerWidth >= 1200) return 8;
        else if (window.innerWidth >= 768) return 6;
        else return 4;
      }
    },
  },
  destroyed() {
    window.onresize = null;
    window.removeEventListener("resize", this.updateBackgroundHeight);
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    // 根据幻灯片数量动态调整Swiper配置
    // 在methods中更新updateSwiperOptions方法

    updateSwiperOptions() {
      const slideCount = this.slides.length;
      const baseOptions = {
        // 共用基础配置
        centeredSlides: true,
        spaceBetween: this.offsetwidth > 850 ? 46 : 15,
        resistance: true,
        resistanceRatio: 0.98,
        iOSEdgeSwipeDetection: true,
        touchEventsTarget: "container",
        touchAngle: 45,
        threshold: 10,
        slideToClickedSlide: true,
        // 自动轮播
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
      };

      // PC端配置
      const pcOptions = {
        ...baseOptions,
        // PC端特定配置
        slidesPerView: "auto",
        spaceBetween: 46,
      };

      // 移动端配置
      const h5Options = {
        ...baseOptions,
        // 移动端特定配置
        slidesPerView: "auto",
        spaceBetween: 15,
      };

      // 根据幻灯片数量调整配置
      if (slideCount <= 1) {
        // 只有1张幻灯片时
        Object.assign(pcOptions, {
          slidesPerView: 1,
          centeredSlides: true,
          loop: false,
          autoplay: false, // 只有一张时禁用自动轮播
        });

        Object.assign(h5Options, {
          slidesPerView: 1,
          centeredSlides: true,
          loop: false,
          autoplay: false,
        });
      } else if (slideCount <= 3) {
        // 2-3张幻灯片时 - 关键修复：使用整数slidesPerView
        const isMobile = this.offsetwidth <= 850;

        // PC端：2张显示2张，3张显示3张
        const pcSlidesPerView = Math.min(slideCount, 2); // PC显示2张或3张

        Object.assign(pcOptions, {
          slidesPerView: pcSlidesPerView,
          centeredSlides: slideCount === 2 ? false : true, // 只有2张时不居中
          loop: false, // 禁用循环模式
          slidesPerGroup: 1, // 每次滑动一张
          watchSlidesProgress: true,
          touchRatio: 0.5, // 减小触摸灵敏度
        });

        // 移动端：2张显示1.5张，3张显示1.5张
        const mobileSlidesPerView = slideCount === 2 ? 1.8 : 1.5; // 移动端使用小数显示部分内容

        Object.assign(h5Options, {
          slidesPerView: mobileSlidesPerView,
          centeredSlides: slideCount === 2 ? false : true, // 只有2张时不居中
          loop: false, // 禁用循环模式
          slidesPerGroup: 1, // 每次滑动一张
          watchSlidesProgress: true,
          touchRatio: 0.5, // 减小触摸灵敏度
        });

        // 如果是PC端且只有2张，添加偏移使居中显示
        if (!isMobile && slideCount === 2) {
          Object.assign(pcOptions, {
            slidesOffsetBefore: 0, // 移除偏移
            centeredSlidesBounds: true,
          });
        }
      } else {
        // 大于3张时启用完整功能
        Object.assign(pcOptions, {
          loop: true,
          slidesPerView: "auto",
          centeredSlides: true,
          loopAdditionalSlides: 5,
          loopFix: true,
          on: this.getSwiperEvents(),
        });

        Object.assign(h5Options, {
          loop: true,
          slidesPerView: "auto",
          centeredSlides: true,
          loopAdditionalSlides: 5,
          loopFix: true,
          on: this.getSwiperEvents(),
        });
      }

      // 更新动态配置
      this.dynamicSwiperOptions = pcOptions;
      this.dynamicSwiperOptionsH5 = h5Options;
    },
    // 添加修复滑动的方法
    fixSlidePosition() {
      if (this.swiperInstance && this.slides.length <= 3) {
        // 重新计算并更新Swiper位置
        this.$nextTick(() => {
          this.swiperInstance.update();
          this.swiperInstance.slideTo(0, 0); // 重置到第一张
        });
      }
    },
    // 获取Swiper事件处理器（用于多张幻灯片）
    getSwiperEvents() {
      return {
        init: function () {
          this.loopCreate();
          this.update();
          setTimeout(() => {
            this.loopDestroy();
            this.loopCreate();
            this.update();
          }, 100);
        },
        slideChange: function () {
          if (this.slides.length <= 4) return;
          const safeIndex = Math.min(
            this.slides.length - 4,
            Math.max(0, this.realIndex)
          );
          if (this.realIndex >= this.slides.length - 3) {
            this.slideTo(safeIndex);
          }
        },
        reachEnd: function () {
          if (this.slides.length <= 4) return;
          this.slideTo(this.slides.length - 4);
        },
        touchStart: function () {
          this.allowTouchMove = true;
        },
      };
    },
    updateBackgroundHeight() {
      const container = document.querySelector(".background-container");
      if (container) {
        const width = container.clientWidth;
        this.imgHeightlunbo = `${this.dynamicHeight(width)}px`;
      }
    },
    // 处理媒体项类型
    processMediaItems(data) {
      return data.map((item) => {
        let type = "unknown";

        try {
          if (item.FileFormat) {
            if (item.FileFormat.startsWith("image/")) {
              type = "image";
            } else if (item.FileFormat.startsWith("video/")) {
              type = "video";
            } else {
              // 备用方案：根据文件扩展名判断
              const fileName = item.FileName || "";
              const extension = fileName.split(".").pop().toLowerCase();
              const imageExtensions = [
                "jpg",
                "jpeg",
                "png",
                "gif",
                "bmp",
                "webp",
                "svg",
              ];
              const videoExtensions = [
                "mp4",
                "avi",
                "mov",
                "wmv",
                "flv",
                "webm",
                "mkv",
              ];

              if (imageExtensions.includes(extension)) {
                type = "image";
              } else if (videoExtensions.includes(extension)) {
                type = "video";
              }
            }
          }
        } catch (error) {
          console.warn("处理文件类型时出错:", error, item);
        }

        // 构建幻灯片对象
        const slide = {
          ...item,
          type: type,
          loadingPoster: false,
          generatedPoster: null,
        };

        // 如果是视频类型，添加默认封面（如果有的话）
        if (type === "video" && !slide.poster) {
          // 可以设置一个默认的视频封面图片
          // slide.poster = require("../assets/default-video-poster.jpg");
        }

        return slide;
      });
    },
    // 获取首页产品轮播展示数据
    async getHomePageProductCarouselDisplay() {
      this.loading = true;
      try {
        const res = await get(HomePageProductCarouselDisplay);
        if (res.data.code == 200) {
          this.imagescopyh5 = res.data.h5Product;
          this.imagescopy = res.data.pcProduct;
          const processedData = this.processMediaItems(res.data.case || []);
          this.slides = processedData;
          // 重要：根据幻灯片数量更新Swiper配置
          this.updateSwiperOptions();
          // 如果有视频，生成视频封面
          if (this.slides.some((slide) => slide.type === "video")) {
            await this.generateAllVideoPosters();
          }

          this.$nextTick(() => {
            this.initSwiper();
          });
        } else {
          console.error("获取数据失败:", res.data);
        }
      } catch (error) {
        console.error("请求失败:", error);
      } finally {
        this.loading = false;
      }
    },
    // 添加对齐方法，确保图标完整显示
    alignToNearestIcon() {
      if (!this.$refs.track) return;

      const trackWidth = this.$refs.track.offsetWidth;
      const visibleCount = Math.floor(trackWidth / this.itemWidth);

      // 计算当前偏移量对应的图标索引
      const currentIconIndex = Math.round(-this.offset / this.itemWidth);

      // 计算对齐后的偏移量
      let alignedOffset = -currentIconIndex * this.itemWidth;

      // 确保不会超出边界
      const maxOffset =
        trackWidth - this.certifications.length * this.itemWidth;
      if (alignedOffset < maxOffset) {
        alignedOffset = maxOffset;
      }
      if (alignedOffset > 0) {
        alignedOffset = 0;
      }

      this.offset = alignedOffset;
      this.updateArrowStates();
    },

    // 修改滚动方法，使用对齐逻辑
    scroll(direction) {
      if (!this.$refs.track) return;

      const trackWidth = this.$refs.track.offsetWidth;
      const listWidth = this.certifications.length * this.itemWidth;

      // 计算当前可见的完整图标数量
      const visibleCount = Math.floor(trackWidth / this.itemWidth);

      // 确保每次滚动完整的图标组
      const step = visibleCount * this.itemWidth;

      // console.log("滚动参数:", {
      //   direction,
      //   step,
      //   visibleCount,
      //   currentOffset: this.offset,
      //   maxOffset: trackWidth - listWidth,
      // });

      if (direction === "left") {
        // 向左滚动
        let newOffset = this.offset + step;
        if (newOffset > 0) newOffset = 0;
        this.offset = newOffset;
      } else {
        // 向右滚动
        let newOffset = this.offset - step;
        const maxOffset = trackWidth - listWidth;
        if (newOffset < maxOffset) newOffset = maxOffset;
        this.offset = newOffset;
      }

      // 滚动后确保图标对齐
      this.$nextTick(() => {
        this.alignToNearestIcon();
      });
    },
    // 修复初始化方法
    initCertScroll() {
      this.$nextTick(() => {
        setTimeout(() => {
          if (
            this.$refs.track &&
            this.$refs.track.querySelector(".cert-icon")
          ) {
            const firstItem = this.$refs.track.querySelector(".cert-icon");
            const style = window.getComputedStyle(firstItem);

            // 精确计算图标实际占用的宽度
            this.itemWidth =
              firstItem.offsetWidth +
              parseInt(style.marginLeft) +
              parseInt(style.marginRight);

            // console.log("图标实际宽度:", this.itemWidth);
            // console.log("轨道宽度:", this.$refs.track.offsetWidth);
            // console.log(
            //   "可见图标数量:",
            //   Math.floor(this.$refs.track.offsetWidth / this.itemWidth)
            // );

            // 确保初始偏移量正确
            this.ensureProperInitialOffset();
            this.updateArrowStates();
          }
        }, 100);
      });
    },

    // 确保正确的初始偏移量
    ensureProperInitialOffset() {
      this.offset = 0;

      if (!this.$refs.track) return;

      const trackWidth = this.$refs.track.offsetWidth;
      const listWidth = this.certifications.length * this.itemWidth;

      // 如果内容宽度小于容器宽度，居中显示
      if (listWidth <= trackWidth) {
        this.offset = (trackWidth - listWidth) / 2;
        this.disableLeft = true;
        this.disableRight = true;
      } else {
        this.disableLeft = true;
        this.disableRight = false;
      }
    },

    // 计算最大偏移量
    calculateMaxOffset() {
      if (!this.$refs.track) return 0;
      const trackWidth = this.$refs.track.offsetWidth;
      const listWidth = this.certifications.length * this.itemWidth;
      return Math.min(0, trackWidth - listWidth);
    },
    // 添加对齐到最近分组的方法
    alignToNearestGroup() {
      // 计算当前偏移量对应的组索引
      const groupIndex = Math.round(-this.offset / this.itemWidth);

      // 计算对齐后的偏移量
      this.offset = -groupIndex * this.itemWidth;

      // 确保不会超出边界
      if (this.offset < this.maxOffset) {
        this.offset = this.maxOffset;
      }
      if (this.offset > 0) {
        this.offset = 0;
      }
    },
    // 修改updateGroupSize方法，更精确地计算分组大小
    updateGroupSize() {
      // 根据屏幕尺寸动态调整每组显示的图标数量
      if (window.innerWidth >= 1200) {
        this.groupSize = 8; // 大屏幕显示8个
      } else if (window.innerWidth >= 768) {
        this.groupSize = 6; // 中等屏幕显示6个
      } else {
        this.groupSize = 4; // 小屏幕显示4个
      }

      // 计算精确的滚动步长
      this.itemWidth = 100; // 每个图标的宽度（含间距）

      // 更新最大偏移量（考虑边界对齐）
      this.maxOffset = -(
        (this.certifications.length - this.groupSize) *
        this.itemWidth
      );

      // 确保当前偏移量对齐到最近的一组
      this.alignToNearestGroup();

      // 更新箭头状态
      this.updateArrowStates();
    },

    // 修复更新箭头状态方法
    updateArrowStates() {
      if (!this.$refs.track) {
        this.disableLeft = true;
        this.disableRight = false;
        return;
      }

      const trackWidth = this.$refs.track.offsetWidth;
      const listWidth = this.certifications.length * this.itemWidth;

      // 添加容差，避免浮点数计算问题
      const tolerance = 1;

      this.disableLeft = this.offset >= -tolerance;
      this.disableRight = this.offset <= trackWidth - listWidth + tolerance;

      // console.log("偏移量状态:", {
      //   offset: this.offset,
      //   maxOffset: trackWidth - listWidth,
      //   disableLeft: this.disableLeft,
      //   disableRight: this.disableRight,
      // });
    },
    // 添加窗口调整大小时的响应
    handleResize() {
      this.imgLoad();
      this.imgLoadcopy();

      // 延迟执行以确保DOM更新完成
      setTimeout(() => {
        this.initCertScroll();
      }, 300);
    },
    //     // 添加更新分组大小的方法
    // updateGroupSize() {
    //   // 根据屏幕尺寸动态调整每组显示的图标数量
    //   if (window.innerWidth >= 1200) {
    //     this.groupSize = 8; // 大屏幕显示8个
    //   } else if (window.innerWidth >= 768) {
    //     this.groupSize = 6; // 中等屏幕显示6个
    //   } else {
    //     this.groupSize = 4; // 小屏幕显示4个
    //   }

    //   // 更新最大偏移量
    //   this.maxOffset = -(
    //     (this.certifications.length - this.groupSize) *
    //     this.itemWidth
    //   );

    //   // 确保当前偏移量不超过最大偏移量
    //   if (this.offset < this.maxOffset) {
    //     this.offset = this.maxOffset;
    //   }

    //   // 更新箭头状态
    //   this.updateArrowStates();
    // },
    // 激活导航项方法
    activateNav(index) {
      this.activeNav = index;
    },
    goto(name) {
      if (name == "HOME") {
        window.sessionStorage.setItem("activeIndexh5", "/index");
        document.documentElement.scrollTop = 0;
        // this.$router.push("/index");
      } else if (name == "PROJECT") {
        window.sessionStorage.setItem("activeIndexh5", "/Project");
        this.$router.push("/Project");
      } else if (name == "PRODUCTS") {
        window.sessionStorage.setItem("activeIndexh5", "/Productslist");
        this.$router.push("/Productslist");
      } else if (name == "CASE") {
        window.sessionStorage.setItem("activeIndexh5", "/Case");
        this.$router.push("/Case");
        // window.open('https://smartuser.com.au/customerdetails/')
        // this.$router.push("/ProjectGallery")
      } else if (name == "CONTACTUS") {
        window.sessionStorage.setItem("activeIndexh5", "/ContactUs");
        this.$router.push("/ContactUs");
      }
    },
    // Process 相关方法
    setHover(step) {
      this.hoverStep = step;
    },
    clearHover() {
      this.hoverStep = null;
    },
    setActive(step) {
      this.activeStep = step;
      this.$router.push("/ContactUs");
    },
    handleStepClick(index) {
      console.log(`点击了步骤 ${index + 1}: ${this.steps[index].title}`);
    },
    handleCarouselClick(item) {
      // 立即跳转到Case页面，携带item参数
      this.$store.commit("SetProductId", item.ToProductId);
      this.$router
        .push({
          path: "/Productinformation",
        })
        .catch((err) => {
          // 防止重复导航错误
          if (err.name !== "NavigationDuplicated") {
            console.error("导航错误:", err);
          }
        });
    },
    handlechanpinSlideChange(index) {
      this.currentIndexcopy = index;
      // this.$router.push("/Productinformation");
    },
    handleSlideChange(index) {
      this.currentIndex = index;
    },
    initSwiper() {
      //  if (this.$refs.centeredSwiper?.$swiper) {
      //   this.swiperInstance = this.$refs.centeredSwiper.$swiper;

      //   // 根据幻灯片数量配置不同的保护机制
      //   if (this.slides.length > 3) {
      //     this.swiperInstance.params.loopFix = true;
      //     this.swiperInstance.params.loopAdditionalSlides = 5;
      //     this.swiperInstance.params.resistanceRatio = 0.98;

      //     // 只在幻灯片多时添加循环保护
      //     this.swiperInstance.on("reachEnd", () => {
      //       this.swiperInstance.slideTo(this.slides.length - 4);
      //     });
      //   }

      //   // 强制更新Swiper
      //   this.swiperInstance.update();
      // }
      if (this.$refs.centeredSwiper?.$swiper) {
        this.swiperInstance = this.$refs.centeredSwiper.$swiper;

        // 根据幻灯片数量配置不同的保护机制
        if (this.slides.length > 3) {
          this.swiperInstance.params.loopFix = true;
          this.swiperInstance.params.loopAdditionalSlides = 5;
          this.swiperInstance.params.resistanceRatio = 0.98;

          // 只在幻灯片多时添加循环保护
          this.swiperInstance.on("reachEnd", () => {
            this.swiperInstance.slideTo(this.slides.length - 4);
          });
        } else {
          // 对于2-3张的情况，添加边界保护
          this.swiperInstance.on("slideChange", () => {
            const currentIndex = this.swiperInstance.activeIndex;
            if (currentIndex >= this.slides.length) {
              this.swiperInstance.slideTo(this.slides.length - 1);
            }
          });
        }

        // 强制更新Swiper
        this.swiperInstance.update();

        // 对于少量幻灯片，修复位置
        if (this.slides.length <= 3) {
          this.fixSlidePosition();
        }
      }
    },
    // 添加新的CSS类来控制少量幻灯片时的样式
    getSlideClass(index) {
      const slideCount = this.slides.length;
      if (slideCount <= 3) {
        return {
          "slide-item": true,
          "few-slides": true,
          "active-slide": this.isActive(index),
          // 根据数量添加不同的类
          "two-slides": slideCount === 2,
          "three-slides": slideCount === 3,
        };
      }
      return {
        "slide-item": true,
        "active-slide": this.isActive(index),
      };
    },
    // 添加页面响应式更新
    onResize() {
      this.updateSwiperOptions();
      if (this.swiperInstance) {
        setTimeout(() => {
          this.swiperInstance.update();
        }, 100);
      }
    },
    // 生成所有视频封面
    async generateAllVideoPosters() {
      const videoSlides = this.slides.filter((slide) => slide.type === "video");
      const promises = videoSlides.map((slide, index) =>
        this.generateVideoPoster(this.slides.indexOf(slide))
      );

      await Promise.allSettled(promises);
    },

    // 生成视频封面
    generateVideoPoster(index) {
      return new Promise((resolve) => {
        const videoRef = `video-${index}`;
        const videoElement = this.$refs[videoRef]
          ? this.$refs[videoRef][0]
          : null;

        if (!videoElement) {
          console.warn(`视频元素 ${videoRef} 未找到`);
          resolve();
          return;
        }

        this.slides[index].loadingPoster = true;

        const onLoadedMetadata = () => {
          try {
            videoElement.currentTime = 0.1;
          } catch (error) {
            console.error("设置视频时间失败:", error);
            this.slides[index].loadingPoster = false;
            resolve();
          }
        };

        const onSeeked = () => {
          try {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            canvas.width = videoElement.videoWidth;
            canvas.height = videoElement.videoHeight;
            ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
            const posterDataURL = canvas.toDataURL("image/jpeg", 0.8);

            this.slides[index].generatedPoster = posterDataURL;
            this.slides[index].loadingPoster = false;

            videoElement.removeEventListener(
              "loadedmetadata",
              onLoadedMetadata
            );
            videoElement.removeEventListener("seeked", onSeeked);
            resolve();
          } catch (error) {
            console.error("生成视频封面失败:", error);
            this.slides[index].loadingPoster = false;
            resolve();
          }
        };

        const onError = (error) => {
          console.error(`视频 ${index} 加载失败:`, error);
          this.slides[index].loadingPoster = false;
          videoElement.removeEventListener("loadedmetadata", onLoadedMetadata);
          videoElement.removeEventListener("seeked", onSeeked);
          videoElement.removeEventListener("error", onError);
          resolve();
        };

        videoElement.addEventListener("loadedmetadata", onLoadedMetadata);
        videoElement.addEventListener("seeked", onSeeked);
        videoElement.addEventListener("error", onError);

        // 如果视频已经加载了元数据
        if (videoElement.readyState >= 1) {
          onLoadedMetadata();
        }

        // 设置超时
        setTimeout(() => {
          if (this.slides[index].loadingPoster) {
            console.warn(`视频封面生成超时: ${index}`);
            this.slides[index].loadingPoster = false;
            videoElement.removeEventListener(
              "loadedmetadata",
              onLoadedMetadata
            );
            videoElement.removeEventListener("seeked", onSeeked);
            videoElement.removeEventListener("error", onError);
            resolve();
          }
        }, 10000); // 10秒超时
      });
    },
    onVideoLoaded(index) {
      if (
        this.slides[index].type === "video" &&
        !this.slides[index].generatedPoster &&
        !this.slides[index].loadingPoster
      ) {
        this.generateVideoPoster(index);
      }
    },

    onSlideChange() {
      if (this.swiperInstance) {
        this.currentActiveIndex = this.swiperInstance.realIndex;
        this.pauseInactiveVideos();
      }
    },

    slideTo(index) {
      //  console.log(index);
      if (this.swiperInstance) {
        // 在循环模式下使用 slideToLoop 方法
        this.swiperInstance.slideToLoop(index);
      }
      // console.log(index);
      // if (this.swiperInstance) {
      //   const realIndex = index % this.slides.length;
      //   this.swiperInstance.slideTo(realIndex);
      //   this.currentActiveIndex = realIndex;
      // }
    },

    isActive(index) {
      if (!this.swiperInstance) return false;
      const realIndex = this.swiperInstance.realIndex;
      const totalSlides = this.slides.length;

      return (
        index === realIndex ||
        (realIndex >= totalSlides && index === 0) ||
        (realIndex < 0 && index === totalSlides - 1)
      );
    },
    handleSlideClick(slide, index) {
      this.$router.push({
        path: "/Case",
        // query: {
        //   QRMACID: row.QRMACID,
        // },
      });
      // // 防止点击穿透
      // if (!slide || slide.type === 'unknown') return;

      // // 统一跳转逻辑
      // this.handleMediaClick(slide, index);
    },

    // 处理视频点击事件
    handleVideoClick(slide, index) {
      // console.log("点击视频:", slide.FileName, slide);
      // const videoElement = this.$refs[`video-${index}`] ? this.$refs[`video-${index}`][0] : null;
      // if (videoElement) {
      //     if (videoElement.paused) {
      //         videoElement.play();
      //     } else {
      //         videoElement.pause();
      //     }
      // }
      this.$router.push({
        path: "/Case",
        // query: {
        //   QRMACID: row.QRMACID,
        // },
      });
    },
    // 处理图片点击事件
    handleimageClick() {
      this.$router.push({
        path: "/Case",
        // query: {
        //   QRMACID: row.QRMACID,
        // },
      });
    },
    // 暂停非当前视频
    pauseInactiveVideos() {
      const videos = document.querySelectorAll(".media-element");
      videos.forEach((video, index) => {
        if (index !== this.currentActiveIndex && video.pause) {
          video.pause();
        }
      });
    },
    // scroll(direction) {
    //   const step = this.itemWidth;
    //   if (direction === "left") {
    //     this.offset = Math.min(0, this.offset + step);
    //   } else {
    //     this.offset = Math.max(this.maxOffset, this.offset - step);
    //   }
    // },
    imgLoad() {
       this.$nextTick(() => {
        // 添加安全检查
    if (this.$refs.imgHeight && this.$refs.imgHeight[0] && this.$refs.imgHeight[0].height) {
      this.imgHeight = this.$refs.imgHeight[0].height + "px";
    }
      });
    },
    imgLoadcopy() {
      this.$nextTick(() => {
        // 添加安全检查
    if (this.$refs.imgHeightcopy && this.$refs.imgHeightcopy[0] && this.$refs.imgHeightcopy[0].height) {
      this.imgHeightcopy = this.$refs.imgHeightcopy[0].height + "px";
    }
      });
    },
    handleImageClick(index) {
      // 1. 立即启动预览动画
      this.startPreviewSequence();

      // 2. 使用Promise确保预览完成后再跳转
      this.ensurePreviewCompletion()
        .then(() => {
          // 3. 安全的路由跳转（带错误处理）
          this.safeRoutePush("/Case");
        })
        .catch((err) => {
          console.error("预览跳转失败:", err);
        });
    },
    startPreviewSequence() {
      this.$nextTick(() => {
        const viewer = document.querySelector(".el-image-viewer");
        if (viewer) {
          this.autoZoom(viewer);
        }
      });
    },

    async ensurePreviewCompletion() {
      // 动态检测预览组件状态
      return new Promise((resolve) => {
        const checkPreview = () => {
          const img = document.querySelector(".el-image-viewer__img");
          if (img && img.style.transform !== "") {
            resolve();
          } else {
            // 最大等待500ms，超时强制跳转
            setTimeout(resolve, 500);
          }
        };

        // 初始检查
        checkPreview();

        // 后续每100ms检查一次
        const interval = setInterval(checkPreview, 100);

        // 清理定时器
        setTimeout(() => {
          clearInterval(interval);
          resolve();
        }, 500);
      });
    },

    safeRoutePush(path) {
      // 防止重复路由报错
      if (this.$route.path !== path) {
        this.$router.push(path).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            console.error("路由错误:", err);
          }
        });
      }
    },
    autoZoom(viewer) {
      // 查找放大按钮并模拟点击
      const zoomInBtn = viewer.querySelector(".el-image-viewer__zoom-in");
      if (zoomInBtn) {
        // 点击两次达到2倍放大效果（可根据需要调整次数）
        zoomInBtn.click();
        setTimeout(() => zoomInBtn.click(), 30);
      }
    },

    // goinfo() {
    //   // window.sessionStorage.setItem("activeIndex", "/CustomerDetails");
    //   this.$emit("fun", "/CustomerDetails");
    // },
  },
};
</script>
<style scoped>
/* 添加Swiper性能优化样式 */
::v-deep .swiper-container {
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}

/* 当幻灯片数量少时的特殊样式 */
.few-slides {
  justify-content: center;
}

/* 优化幻灯片内容 */
.slide-content {
  /* 添加GPU加速 */
  transform: translate3d(0, 0, 0);
  will-change: transform;
  backface-visibility: hidden;
}

/* 禁用循环时的样式优化 */
.no-loop ::v-deep .swiper-wrapper {
  transform: none !important;
  transition-duration: 0ms !important;
}

/* 响应式优化 */
@media (max-width: 768px) {
  /* 移动端优化 */
  ::v-deep .swiper-slide {
    flex-shrink: 0;
  }

  .slide-content {
    width: 150px;
    height: 150px;
  }
}

/* 当只有2-3张幻灯片时的特殊处理 */
@media (max-width: 768px) and (min-slides: 2) and (max-slides: 3) {
  .centered-swiper-container {
    padding: 0 10px;
  }

  .slide-content {
    margin: 0 5px;
  }
}
</style>
<style lang="scss" scoped>
@media (min-width: 1920px) {
  // 1.6
  //    .Certificationsbufen{
  // padding-left:px !important;
  // padding-right:201px !important;
  //   }
  //    .Processbufen{
  // padding-left:297px !important;
  // padding-right:297px !important;
  //   }
  .step-icon {
    width: 76px !important;
    height: 76px !important;
  }
  //   .Certificationsbufen{
  // padding-left:201px !important;
  // padding-right:201px !important;
  //   }
  //    .Processbufen{
  // padding-left:297px !important;
  // padding-right:291px !important;
  //   }
  //   .process-container{
  //     width:100% !important;
  //     padding:20px 297px !important;
  //   }
  //   .process-step{
  //     width:300px !important;
  //   }
  //   .step-title,.step-description{
  //     font-size:18px !important;
  //   }
  // .Processbufen{
  //   padding:50px 207px !important;
  // }
  .stat-number {
    display: flex;
    font-size: 24px !important;
    font-family: Cotyledon-Regular-bold;
    color: #000000;
  }
  .description {
    font-size: 22px !important;
  }
  .section-title {
    font-size: 38px;
    color: #000000;
    font-family: Cotyledon-Regular-bold;
    margin-bottom: 20px;
  }
  .stat-numbeiconpc {
    height: 60px !important;
  }
}
@media (min-width: 1600px) and (max-width: 1919px) {
  // 1.4
  //     .Certificationsbufen{
  // padding-left:176px !important;
  // padding-right:176px !important;
  //   }
  //    .Processbufen{
  // padding-left:260px !important;
  // padding-right:260px !important;
  //   }
  .stat-number {
    display: flex;
    font-size: 25px !important;
    font-family: Cotyledon-Regular-bold;
    color: #000000;
  }
  .description {
    font-size: 19px !important;
  }
  .section-title {
    font-size: 33px;
    color: #000000;
    font-family: Cotyledon-Regular-bold;
    margin-bottom: 20px;
  }
  .stat-numbeiconpc {
    height: 60px !important;
  }
}

@media (min-width: 1440px) and (max-width: 1600px) {
  // 1.26
  //     .Certificationsbufen{
  // padding-left:158px !important;
  // padding-right:158px !important;
  //   }
  // .Processbufen{
  // padding: 50px 90px !important;
  // }
  //    .Processbufen{
  // padding-left:234px !important;
  // padding-right:234px !important;
  //   }
  .step-icon {
    width: 60px !important;
    height: 60px !important;
  }
  .stat-number {
    display: flex;
    font-size: 24px !important;
    font-family: Cotyledon-Regular-bold;
    color: #000000;
  }
  .description {
    font-size: 18px !important;
  }
  .section-title {
    font-size: 30px;
    color: #000000;
    font-family: Cotyledon-Regular-bold;
    margin-bottom: 20px;
  }
  .stat-numbeiconpc {
    height: 60px !important;
  }
}

@media (min-width: 1301px) and (max-width: 1439px) {
  // 1.14
  //     .Certificationsbufen{
  // padding-left:143px !important;
  // padding-right:143px !important;
  //   }
  //    .Processbufen{
  // padding-left:212px !important;
  // padding-right:212px !important;
  //   }
  .Processbufen {
    padding: 50px 20px !important;
  }
  .step-icon {
    width: 54px !important;
    height: 54px !important;
  }
  .stat-number {
    display: flex;
    font-size: 22px !important;
    font-family: Cotyledon-Regular-bold;
    color: #000000;
  }
  .description {
    font-size: 16px !important;
  }
  .section-title {
    font-size: 27px;
    color: #000000;
    font-family: Cotyledon-Regular-bold;
    margin-bottom: 20px;
  }
  .stat-numbeiconpc {
    height: 54px !important;
  }
}
@media (min-width: 1200px) and (max-width: 1300px) {
  //      .Certificationsbufen{
  // padding-left:126px !important;
  // padding-right:126px !important;
  //   }
  //    .Processbufen{
  // padding-left:186px !important;
  // padding-right:186px !important;
  //   }
  .step-icon {
    width: 48px !important;
    height: 48px !important;
  }
  .stat-number {
    display: flex;
    font-size: 20px !important;
    font-family: Cotyledon-Regular-bold;
    color: #000000;
  }
  .description {
    font-size: 14px !important;
  }

  .section-title {
    font-size: 24px;
    color: #000000;
    font-family: Cotyledon-Regular-bold;
    margin-bottom: 20px;
  }
  .stats-container.stat-numbeiconpc {
    font-size: 24px !important;
  }
}
</style>
<style scoped>
/* 移动端Process部分样式 */
.mobile-process-grid {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.mobile-process-container {
  max-width: 90%;
  margin: 0 auto;
  padding: 0 20px;
}

.mobile-process-steps {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.mobile-process-row {
  display: flex;
  justify-content: space-between;
  gap: 15px;
}
.mobile-process-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: relative;
  margin-bottom: 0;
  cursor: pointer;
}

.mobile-step-icon-wrapper {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.mobile-process-step:hover .mobile-step-icon-wrapper {
  transform: scale(1.1);
}

.mobile-step-icon {
  width: 36px; /* 图标实际大小 */
  height: 36px; /* 图标实际大小 */
  /* width: 50px;
  height: 50px; */
  transition: all 0.3s ease;
}

.mobile-step-content {
  text-align: center;
}

.mobile-step-title {
  font-size: 14px;
  /* font-weight: 600; */
  color: #666666;
  transition: color 0.3s ease;
}

.mobile-step-description {
  font-size: 14px;
  color: #666;
  line-height: 1.4;
  transition: color 0.3s ease;
}

.mobile-active-text {
  color: #0c80da !important;
}

.mobile-step-connector {
  width: 2px;
  height: 40px;
  background-color: #e0e0e0;
  margin: 0 auto 30px;
  position: relative;
  z-index: 1;
}
/* 超小屏幕适配 (321px - 375px) */
@media (min-width: 321px) and (max-width: 375px) {
  /* 0.4 */
  .mobliestatnumbericon {
    height: 36px;
  }
  .biaotititle {
    font-size: 20px;
    color: #000000;
    font-family: Cotyledon-Regular-bold;
    margin-bottom: 20px;
  }
  .Safetytitleh5 {
    font-size: 20px !important;
    color: #000000;
    font-family: Cotyledon-Regular-bold;
  }
  .Safetyneirongh5 {
    font-size: 14.5px !important;
  }
  .mobile-process-container {
    padding: 0 15px;
  }

  .mobile-step-icon-wrapper {
    width: 70px;
    height: 70px;
  }

  .mobile-step-icon {
    width: 36px;
    height: 36px;
  }

  .mobile-step-title {
    font-size: 14.5px;
  }

  .mobile-step-description {
    font-size: 14.5px;
  }

  .mobile-step-connector {
    height: 50px;
    margin-bottom: 10px;
  }
}
/* 中屏手机 (iPhone 6/7/8/X) - 376px-414px */
@media (min-width: 376px) and (max-width: 414px) {
  /* 0.5 */
  .mobliestatnumbericon {
    height: 36px;
  }
  .biaotititle {
    font-size: 22px;
    color: #000000;
    font-family: Cotyledon-Regular-bold;
    margin-bottom: 20px;
  }
  .Safetytitleh5 {
    font-size: 22px !important;
    color: #000000;
    font-family: Cotyledon-Regular-bold;
  }
  .Safetyneirongh5 {
    font-size: 15px !important;
  }
  .mobile-process-container {
    padding: 0 15px;
  }

  .mobile-step-icon-wrapper {
    width: 70px;
    height: 70px;
  }

  .mobile-step-icon {
    width: 39px;
    height: 39px;
  }

  .mobile-step-title {
    font-size: 15px;
  }

  .mobile-step-description {
    font-size: 15px;
  }

  .mobile-step-connector {
    height: 50px;
    margin-bottom: 10px;
  }
}
/* 中屏手机 (iPhone 6/7/8/X) - 376px-414px */
@media (min-width: 415px) and (max-width: 480px) {
  /* 0.59 */
  .mobliestatnumbericon {
    height: 42px;
  }
  .biaotititle {
    font-size: 23px;
    color: #000000;
    font-family: Cotyledon-Regular-bold;
    margin-bottom: 20px;
  }
  .Safetytitleh5 {
    font-size: 23px !important;
    color: #000000;
    font-family: Cotyledon-Regular-bold;
  }
  .Safetyneirongh5 {
    font-size: 17px !important;
  }
  .mobile-process-container {
    padding: 0 15px;
  }

  .mobile-step-icon-wrapper {
    width: 70px;
    height: 70px;
  }

  .mobile-step-icon {
    width: 46px;
    height: 46px;
  }

  .mobile-step-title {
    font-size: 17px;
  }

  .mobile-step-description {
    font-size: 17px;
  }

  .mobile-step-connector {
    height: 50px;
    margin-bottom: 10px;
  }
}
/* 小屏平板 - 481px-768px */
@media (min-width: 481px) and (max-width: 768px) {
  /* 0.8 */
  .mobliestatnumbericon {
    height: 58px;
  }
  .biaotititle {
    font-size: 33px;
    color: #000000;
    font-family: Cotyledon-Regular-bold;
    margin-bottom: 20px;
  }
  .Safetytitleh5 {
    font-size: 33px !important;
    color: #000000;
    font-family: Cotyledon-Regular-bold;
  }
  .Safetyneirongh5 {
    font-size: 23px !important;
  }
  .mobile-process-container {
    padding: 0 15px;
  }

  .mobile-step-icon-wrapper {
    width: 70px;
    height: 70px;
  }

  .mobile-step-icon {
    width: 58px;
    height: 58px;
  }

  .mobile-step-title {
    font-size: 23px;
  }

  .mobile-step-description {
    font-size: 23px;
  }

  .mobile-step-connector {
    height: 50px;
    margin-bottom: 10px;
  }
}
/* @media (max-width: 480px) {
  .mobile-process-container {
    padding: 0 15px;
  }

  .mobile-step-icon-wrapper {
    width: 70px;
    height: 70px;
  }

  .mobile-step-icon {
    width: 40px;
    height: 40px;
  }

  .mobile-step-title {
    font-size: 14px;
  }

  .mobile-step-description {
    font-size: 14px;
  }

  .mobile-step-connector {
    height: 50px;
    margin-bottom: 10px;
  }
} */
</style>
<style scoped>
/* 移动端革命性发电方法部分 */
.mobile-revolution-section {
  padding: 20px;
  text-align: center;
}

/* .mobile-revolution-section .section-title {
  font-size: 18px;
  margin-bottom: 15px;
} */

.mobile-revolution-section .description {
  font-size: 14px;
  line-height: 1;
  margin-bottom: 15px;
}
/* 小屏手机 - 321px-375px */
@media (min-width: 321px) and (max-width: 375px) {
  .mobile-revolution-section .description {
    font-size: 18px !important;
    line-height: 1;
    margin-bottom: 15px;
  }

  .mobile-stats-container .stat-number {
    font-size: 18px !important;
  }
  .mobile-stats-container {
    gap: 14px !important;
    max-width: 200px !important;
  }
}

/* 中屏手机 (iPhone 6/7/8/X) - 376px-414px */
@media (min-width: 376px) and (max-width: 414px) {
  .mobile-revolution-section .description {
    font-size: 18px !important;
    line-height: 1;
    margin-bottom: 15px;
  }
  .mobile-stats-container .stat-number {
    font-size: 18px !important;
  }
  .mobile-stats-container {
    gap: 14px !important;
    max-width: 200px !important;
  }
}

/* 大屏手机 - 415px-480px */
@media (min-width: 415px) and (max-width: 480px) {
  .mobile-revolution-section .description {
    font-size: 21px !important;
    line-height: 1;
    margin-bottom: 15px;
  }
  .mobile-stats-container .stat-number {
    font-size: 21px !important;
  }
  .mobile-stats-container {
    gap: 18px !important;
    max-width: 230px !important;
  }
}

/* 小屏平板 - 481px-768px */
@media (min-width: 481px) and (max-width: 768px) {
  .mobile-revolution-section .description {
    font-size: 29px !important;
    line-height: 1;
    margin-bottom: 15px;
  }
  .mobile-stats-container .stat-number {
    font-size: 29px !important;
  }
  .mobile-stats-container {
    gap: 28px !important;
    max-width: 230px !important;
  }
}
/* 移动端统计项容器包装器 - 用于居中 */
.mobile-stats-container-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
/* 移动端统计项容器 - 两列布局 */
.mobile-stats-container {
  display: flex;
  flex-direction: column; /* 垂直排列 */
  align-items: flex-start; /* 左对齐 */
  gap: 12px; /* 项目间距 */
  max-width: 200px; /* 限制最大宽度 */
  width: 100%; /* 宽度自适应 */
}

.mobile-stats-container .stat-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  /* background: #f8f9fa;
  border-radius: 8px; */
  padding: 6px 0;
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05); */
}

.mobile-stats-container .stat-number {
  font-size: 14px;
  font-family: Cotyledon-Regular-bold;
  /* font-weight: bold; */
  color: #000;
  display: flex;
  align-items: center;
  justify-content: flex-start; /* 左对齐 */
}

/* 响应式调整 */
@media (max-width: 360px) {
  .mobile-stats-container {
    gap: 10px;
    max-width: 210px !important;
  }

  .mobile-stats-container .stat-item {
    padding: 10px;
  }
}
</style>
<style scoped>
/* Process 部分样式 */
.process-container {
  width: 100%; /* 改为100%宽度 */
  max-width: 1400px; /* 增加最大宽度 */
  margin: 0 auto;
  padding: 20px 20px; /* 增加内边距 */
}

.process-steps {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
}

.process-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  position: relative;
  z-index: 2;
  cursor: pointer;
  transition: all 0.3s ease;
}

.step-icon-wrapper {
  width: 48px; /* 调整为48px */
  height: 48px; /* 调整为48px */
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  transition: transform 0.3s ease;
}

.process-step:hover .step-icon-wrapper {
  transform: scale(1.1);
}

.step-icon {
  width: 48px; /* 调整为48px */
  height: 48px; /* 调整为48px */
  transition: all 0.3s ease;
}

.step-title {
  font-size: 14px;
  font-weight: 600;
  /* margin-bottom: 8px; */
  color: #333;
  transition: color 0.3s ease;
  text-align: center;
}

.process-step:hover .step-title,
.process-step.active .step-title {
  color: #0c80da;
}
.process-step:hover .step-description,
.process-step.active .step-description {
  color: #0c80da;
}

.step-description {
  font-size: 14px;
  color: #666;
  text-align: center;
  min-height: 20px;
}

/* 连接线样式 */
.step-connector {
  flex: 1;
  height: 2px;
  background-color: #e0e0e0;
  margin: 40px 0px 0;
  position: relative;
  z-index: 1;
  transition: background-color 0.3s ease;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .process-steps {
    flex-direction: column;
    align-items: center;
  }

  .process-step {
    margin-bottom: 30px;
    width: 100%;
    max-width: 200px;
  }

  .step-connector {
    width: 2px;
    height: 30px;
    margin: 0 auto;
  }
}
</style>
<style scoped>
.Safetytitleh5 {
  font-size: 22px;
  color: #000000;
  font-family: Cotyledon-Regular-bold;
}
.Safetyneirongh5 {
  margin-top: 3px !important;
  font-size: 14px;
  padding-left: 40px;
  padding-right: 40px;
}
.Safetytitle {
  font-size: 24px;
  color: #000000;
  font-family: Cotyledon-Regular-bold;
}
.Safetyneirong {
  margin-top: 8px;
  font-size: 14px;
}
/* 9000+tubiao  */
.revolution-section {
  padding: 50px 146px; /* 上下50px，左右146px */
  text-align: center;
  max-width: 100%;
  box-sizing: border-box; /* 确保padding包含在宽度内 */
}

.section-title {
  font-size: 24px;
  color: #000000;
  font-family: Cotyledon-Regular-bold;
  margin-bottom: 16px;
}

.description {
  font-size: 14px;
  color: #666666;
  line-height: 1.6;
  /* max-width: 800px; */
  /* margin: 0 auto 0px; */
}

.stats-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 2列等宽 */
  gap: 24px;
  max-width: 1200px;
  margin: 0 auto;
  /* 新增以下对齐配置 */
  justify-items: center; /* 水平居中网格项 */
  align-items: center; /* 垂直居中网格项 */
}
.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* width: 120px; */
}

.stat-icon {
  font-size: 24px;
  margin-bottom: 8px;
}

.stat-number {
  display: flex;
  font-size: 24px;
  font-family: Cotyledon-Regular-bold;
  color: #000000;
}
</style>
<style scoped>
/* 产品轮播背景容器 */
.background-container {
  position: relative;
  width: 100%;
  min-height: 600px;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 透明前景轮播图样式 */
.transparent-carousel-container {
  max-width: 100% !important; /* 移除1200px限制 */
  height: 100%; /* 填充父容器高度 */
  width: 100%;
  margin: 0 auto;
  padding: 20px;
}

.transparent-slide {
  background: transparent !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.transparent-slide-image {
  width: 100%;
  /* max-width: 1200px; */
  height: 600px;
  object-fit: cover !important; /* 改为cover确保完全覆盖 */
  background: transparent;
  mix-blend-mode: multiply; /* 混合模式增强透明效果 */
  opacity: 0.9; /* 轻微透明度 */
  cursor: pointer;
  transition: all 0.3s ease;
}
/* 确保第二个轮播图使用相同的创意效果样式 */
.transparent-carousel-container .creative-slide {
  width: 100%;
  transition: all 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transform: scale(0.3);
  opacity: 0.7;
}

.transparent-carousel-container .active-slide {
  transform: scale(1);
  opacity: 1;
}
.transparent-carousel-container .slide-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* border-radius: 8px; */
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}
/* .transparent-slide-image:hover {
  opacity: 1;
  transform: scale(1.02);
} */

/* 确保轮播组件透明 */
::v-deep .el-carousel {
  background: transparent !important;
}

::v-deep .el-carousel__container {
  background: transparent !important;
}

::v-deep .el-carousel__item {
  background: transparent !important;
}

/* 创意幻灯片效果调整 */
.creative-slide.transparent {
  background: transparent;
  transform: scale(0.25);
  opacity: 0.8;
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.creative-slide.transparent.active-slide {
  transform: scale(1);
  opacity: 1;
}
/* 创意卡片基础样式 */
.creative-slide {
  width: 100%;
  /* height: 400px; */
  margin: 0 auto;
  transition: all 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transform: scale(0.3);
  opacity: 0.7;
}

/* 激活项样式 */
.active-slide {
  transform: scale(1);
  opacity: 1;
}

.slide-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* border-radius: 8px; */
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

/* 自定义箭头样式 */
::v-deep .el-carousel__arrow {
  background-color: rgba(255, 255, 255, 0.8);
  color: #409eff;
  font-size: 24px;
}
</style>
<style scoped>
/* 修复移动端轮播图分页器样式 */
@media (max-width: 768px) {
  /* 方法1：使用正确的深度选择器语法 */
  .home-pageh5 ::v-deep .el-carousel__indicator--horizontal {
    padding: 0 !important;
    margin: 0 2px !important;
  }

  /* 方法2：更具体的分页器容器样式 */
  .home-pageh5 ::v-deep .el-carousel__indicators {
    display: flex !important;
    flex-wrap: nowrap !important;
    justify-content: center !important;
    align-items: center !important;
    gap: 4px !important;
    padding: 0 10px !important;
    overflow-x: auto !important;
    max-width: 100% !important;
  }

  /* 方法3：分页点样式优化 */
  .home-pageh5 ::v-deep .el-carousel__indicator {
    padding: 0 !important;
    margin: 0 2px !important;
    flex-shrink: 0 !important;
  }

  .home-pageh5 ::v-deep .el-carousel__button {
    width: 6px !important;
    height: 6px !important;
    border-radius: 3px !important;
    margin: 0 !important;
    transition: all 0.3s ease !important;
  }

  .home-pageh5 ::v-deep .el-carousel__indicator.is-active .el-carousel__button {
    width: 6px !important;
    background-color: #409eff !important;
  }
}

/* 如果上面的方法还不生效，尝试这个更强制的方法 */
@media (max-width: 768px) {
  /* 强制样式 - 使用属性选择器提高优先级 */
  .home-pageh5[data-v-xxxxx] ::v-deep .el-carousel__indicator--horizontal,
  .home-pageh5 ::v-deep [class*="el-carousel__indicator--horizontal"] {
    padding: 0 !important;
    margin: 0 1px !important;
  }

  /* 分页器容器紧凑布局 */
  .home-pageh5
    ::v-deep
    .el-carousel__indicators.el-carousel__indicators--horizontal {
    gap: 2px !important;
    padding: 8px 5px !important;
  }
}
</style>
<style scoped>
/* 原有的样式保持不变，只添加新的样式 */

.loading-container,
.empty-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  color: #666;
}

.loading-container p,
.empty-container p {
  margin-top: 15px;
  font-size: 16px;
}

/* 其他原有样式保持不变 */
.centered-swiper-container {
  width: 100%;
  max-width: none;
  margin: 0 auto;
  padding: 20px 0;
  overflow: hidden;
}

::v-deep .swiper-container {
  width: 100% !important;
  cursor: grab;
}

::v-deep .swiper-wrapper {
  width: 100% !important;
}

::v-deep .swiper-slide {
  width: auto !important;
}

::v-deep .swiper-slide-duplicate {
  width: auto !important;
}

::v-deep .swiper-slide-prev,
::v-deep .swiper-slide-next {
  width: auto !important;
}

.slide-item {
  opacity: 1;
}

.slide-item.active-slide {
  opacity: 1;
  z-index: 10;
}

.slide-content {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  width: 263px; /* PC端宽度263px */
  height: 240px; /* PC端高度240px */
  margin: 0 0px; /* 间距46px的一半，因为spaceBetween是46 */
}

.media-element {
  width: 263px;
  height: 240px;
  object-fit: cover;
  display: block;
}

.slide-content:hover {
  filter: brightness(1.2);
  transform: scale(1.05);
}

.video-container {
  position: relative;
  overflow: hidden;
  width: 263px;
  height: 240px;
}

video.media-element {
  background: #000;
  width: 263px;
  height: 240px;
}

.video-loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 263px;
  height: 240px;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.custom-pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  gap: 8px;
  padding: 0 20px;
}

.custom-bullet {
  width: 5px;
  height: 5px;
  border-radius: 6px;
  background: #409eff;
  cursor: pointer;
  position: relative;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.custom-bullet.active-bullet {
  width: 30px;
  height: 5px;
  border-radius: 3px;
  background: #409eff;
  transform: scale(1.1);
}

.bullet-inner {
  width: 100%;
  height: 100%;
  border-radius: inherit;
  background: inherit;
  transition: all 0.3s ease;
}

.custom-bullet:hover {
  background: #66b1ff;
  transform: scale(1.05);
}

.custom-bullet.active-bullet:hover {
  background: #409eff;
  transform: scale(1.15);
}

/* 响应式设计 - 移动端调整为150px */
@media (max-width: 768px) {
  .centered-swiper-container {
    /* padding: 10px; */
    width: 100%;
    max-width: none;
  }

  ::v-deep .swiper-slide {
    width: auto !important;
  }

  .slide-content {
    width: 150px;
    height: 150px;
  }

  .media-element {
    width: 150px;
    height: 150px;
  }

  .video-container {
    width: 150px;
    height: 150px;
  }

  video.media-element {
    width: 150px;
    height: 150px;
  }

  .video-loading {
    width: 150px;
    height: 150px;
  }

  .custom-pagination-container {
    gap: 6px;
    margin-top: 20px;
  }

  .custom-bullet {
    width: 5px;
    height: 5px;
  }

  .custom-bullet.active-bullet {
    width: 25px;
    height: 5px;
  }
}

/* 小屏幕手机特别优化 */
@media (max-width: 480px) {
  .slide-content {
    width: 150px;
    height: 150px;
  }

  .media-element {
    width: 150px;
    height: 150px;
  }

  .video-container {
    width: 150px;
    height: 150px;
  }

  video.media-element {
    width: 150px;
    height: 150px;
  }

  .video-loading {
    width: 150px;
    height: 150px;
  }
}
</style>
<style scoped>
.process-timeline {
  position: relative;
  display: flex;
  justify-content: center;
  max-width: 1000px;
  margin: 0 auto;
  padding: 50px 0;
}

.process-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 200px;
  position: relative;
  z-index: 2;
}

.step-icon-wrapper {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  margin-bottom: 15px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.step-icon-wrapper:hover {
  transform: scale(1.15);
}

.step-icon {
  width: 50px;
  height: 50px;
  transition: all 0.3s ease;
}

.step-title {
  font-size: 14px;
  font-weight: 600;
  /* margin-bottom: 8px; */
  color: #666;
}

.step-description {
  font-size: 14px;
  color: #666;
  font-weight: 600;
  text-align: center;
}

/* 连接线样式 */
.timeline-line {
  position: absolute;
  top: 40px;
  height: 1px;
  background: rgb(102, 102, 102);
  z-index: 1;
  width: 100%;
  left: 0;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .process-timeline {
    flex-direction: column;
    align-items: center;
  }

  .process-step {
    margin-bottom: 80px;
    width: auto;
    max-width: 200px;
  }

  .timeline-line {
    top: auto;
    bottom: -40px;
    width: 3px;
    height: 40px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
<style scoped lang="scss">
#click-scroll-X {
  //   background-color: lightgray;
  //   display: flex;
  //   align-items: center;
  //   position: relative;

  .left_btn,
  .right_btn {
    font-size: 30px;
    cursor: pointer;
    color: rgb(3, 107, 185);
    transition: color 0.3s;
    flex-shrink: 0; /* 防止箭头被挤压 */
    font-weight: 700;
    &:hover {
      color: #036bb9ba; /* Element UI主题色 */
    }
  }

  .scroll_wrapper {
    width: 600px;
    overflow-x: scroll;
    padding: 10px 0;

    /* 隐藏所有浏览器滚动条的通用方案 */
    -ms-overflow-style: none; /* IE/Edge */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      /* Chrome/Safari/Opera */
      display: none;
      width: 0;
      height: 0;
      background: transparent;
    }

    .scroll_list {
      display: flex;
      align-items: center;
      gap: 1px; /* 使用gap代替space-between控制间距 */
      width: max-content; /* 关键：让内容自然撑开宽度 */
      padding: 0 10px; /* 添加边距防止内容贴边 */

      .item {
        min-width: 100px;
        height: 42px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: black !important;
        background: #fff;
        border: 1px solid #ddd !important;
        transition: all 0.3s;

        /* 选中状态样式 */
        &.el-button--primary {
          background: #409eff !important;
          border-color: #409eff !important;
          color: white !important;
        }

        &:hover {
          border-color: #409eff !important;
          color: white !important;
          transform: translateY(-2px);
        }
      }
    }
  }
}
::v-deep .el-carousel__indicator.is-active .el-carousel__button {
  background-color: #409eff !important;
}
::v-deep .el-carousel__arrow--left {
  border: none;
  outline: 0;
  padding: 0;
  margin: 0;
  height: 56px;
  width: 56px;
  cursor: pointer;
  transition: 0.3s;
  border-radius: 50%;
  background-color: #c0c4cc;
  color: #fff;
  position: absolute;
  top: 50%;
  z-index: 10;
  transform: translateY(-50%);
  text-align: center;
  font-size: 30px;
  // top: 70px;
  // left: -13px;
  // font-size: 15px;
  // color: #02E9FF;
  // display: none;
}
//右箭头
::v-deep .el-carousel__arrow--right {
  border: none;
  outline: 0;
  padding: 0;
  margin: 0;
  height: 56px;
  width: 56px;
  cursor: pointer;
  transition: 0.3s;
  border-radius: 50%;
  background-color: #c0c4cc;
  color: #fff;
  position: absolute;
  top: 50%;
  z-index: 10;
  transform: translateY(-50%);
  text-align: center;
  font-size: 30px;
  // display: none;
  // top: 70px;
  // right: -13px;
  // font-size: 15px;
  // color: #02E9FF;
}
::v-deep .el-carousel__button {
  left: auto;
  right: 10px;
  bottom: 10px;
  text-align: right;
  // top: 4.5%;
  // right: 22%;
  display: block;
  opacity: 0.48;
  width: 8px;
  height: 8px;
  background-color: #fff;
  border: none;
  outline: 0;
  padding: 0;
  margin: 5px;
  border-radius: 50%;
  cursor: pointer;
  transition: 0.3s;
}
/* 全局样式 - 放在你的全局CSS文件中 */
/* 增加预览容器尺寸 */
/* .el-image-viewer__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
} */

/* 设置初始放大比例 */
/* .el-image-viewer__img {
  transform: scale(1.2) !important;
  transition: transform 0.3s ease;
} */

/* 隐藏操作按钮（可选） */
/* .el-image-viewer__btn {
  display: none !important;
} */
</style>
<style scoped>
.image-row {
  /* 这里可以添加额外的行样式，但通常 <el-row> 会有默认的样式 */
  margin: 0; /* 去除行容器的外边距 */
}

.image-col {
  /* 由于我们使用了 :gutter="0"，这里通常不需要额外的间距样式 */
  padding: 0; /* 去除列容器的内边距（虽然 <el-col> 默认可能没有内边距） */
}

.image-container {
  display: flex;
  flex-wrap: wrap; /* 允许换行 */
  gap: 0; /* 设置图片之间的间距为0 */
  margin: 0; /* 去除容器自身的外边距 */
  padding: 0; /* 去除容器自身的内边距 */
}

.image-container > el-image {
  flex: 0 0 calc(50% - 0px); /* 每列占据50%的宽度，0px是调整间距的，这里不需要额外间距 */
  box-sizing: border-box; /* 确保内边距和边框包含在宽度内 */
}

.vc_custom_1627269981297copy {
  /* margin-bottom: -40px !important; */
  padding-top: 50px !important;
  padding-bottom: 40px !important;
  background-color: #84b903 !important;
}
/* .vc_custom_1626061515335 {
  margin-bottom: -40px !important;
  padding-top: 50px !important;
  padding-bottom: 40px !important;
  background-color: #84b903 !important;
} */
/* .special-link {
  text-decoration: underline;
}
a:link {
  color: blue;
} */
/* 已访问的链接 */
/* a:visited {
  color: purple;
} */

/* 鼠标悬浮在链接上 */
/* a:hover {
  color: red;
} */

/* .mt_20 {
  margin-top: 20px;
}
.mt_10 {
  margin-top: 10px;
}
.text_bold {
  font-weight: 700;
}
.pcss {
  font-family: Poppins;
  font-weight: 300;
  font-style: normal;
  font-size: 15px;
}
.titlecss {
  font-family: Poppins;
  font-style: normal;
} */

/* 图片容器相对定位 */
.banner-text {
  position: absolute;
  top: 50%;
  left: 10%;
  transform: translateY(-50%);
  color: white;
  text-align: left;
  z-index: 10;
}

.text-line-1 {
  font-size: clamp(24px, 3vw, 48px);
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 8px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.text-line-2 {
  font-size: clamp(18px, 2.2vw, 36px);
  font-weight: 600;
  line-height: 1.2;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .banner-text {
    left: 8%;
  }
}

@media (max-width: 992px) {
  .banner-text {
    left: 6%;
  }
}

@media (max-width: 768px) {
  .banner-text {
    left: 5%;
  }

  .text-line-1 {
    font-size: clamp(20px, 4vw, 32px);
  }

  .text-line-2 {
    font-size: clamp(16px, 3vw, 24px);
  }
}
.certifications-container {
  padding: 40px 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.title {
  text-align: center;
  margin-bottom: 30px;
  color: #333;
}

.icons-wrapper {
  position: relative;
  max-width: 100%;
}

.icons-track {
  overflow: hidden;
  width: calc(100% - 80px); /* 为箭头留出空间 */
  margin: 0 20px;
}

.icons-list {
  display: flex;
  transition: transform 0.3s ease;
  justify-content: flex-start; /* 确保左对齐 */
  padding: 10px 0;
  min-width: min-content; /* 确保列表不会被压缩 */
}
.cert-icon {
  flex-shrink: 0;
  width: 100px; /* 调整后宽度 */
  height: 60px; /* 调整后高度 */
  margin: 0 2px; /* 调整间距 */
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.cert-icon img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  transition: filter 0.3s ease, transform 0.3s ease;
}

.cert-icon:hover img {
  filter: brightness(1.2);
  transform: scale(1.05);
}

.arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid #ddd;
  border-radius: 50%;
  cursor: pointer;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.arrow:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.left {
  left: 0;
}

.right {
  right: 0;
}

/* 添加以下CSS样式 */
/* 证书容器样式 */
.cert-container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 2px;
}
/* 箭头按钮样式 */
.left_btn,
.right_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px; /* 稍微宽一点以便点击 */
  height: 40px;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.left_btn:hover,
.right_btn:hover {
  transform: scale(1.1);
}

.left_btn:active,
.right_btn:active {
  transform: scale(0.95);
}
.icons-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icons-track {
  overflow: hidden;
  margin: 0 40px; /* 为箭头留出空间 */
}

.icons-list {
  display: flex;
  transition: transform 0.3s ease;
  padding: 10px 0;
  justify-content: center;
}

/* 调整箭头按钮位置 */
.arrow {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid #ddd;
  border-radius: 50%;
  cursor: pointer;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  top: auto;
  transform: none;
}
/* 平板设备 */
@media (max-width: 992px) {
  .cert-container {
    max-width: 800px;
  }
  .cert-icon {
    width: 100px;
    height: 60px;
  }
}

/* 手机设备 */
@media (max-width: 768px) {
  .cert-container {
    max-width: 100%;
    padding: 0 10px;
  }
  .cert-icon {
    width: 80px;
    height: 50px;
    margin: 0 8px;
  }
}
</style>
<style scoped>
.header-navbar {
  padding: 20px 40px;
  background-color: white;
  /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); */
}
.top-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.logo-container {
  flex-shrink: 0;
}
.logo {
  display: flex;
  align-items: center;
  gap: 8px;
}
.logo-icon {
  font-size: 24px;
}
.logo-text {
  font-size: 18px;
  font-weight: 600;
}
.nav-items {
  display: flex;
  gap: 30px;
}
.nav-item {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  transition: all 0.3s;
  padding: 5px 0;
  position: relative;
  border-bottom: 2px solid transparent;
}
/* 悬停和激活状态统一效果 */
.nav-item:hover,
.nav-item.active {
  color: #0c80da !important;
  /* border-bottom-color: #0c80da !important; */
}
/* 下划线动画效果 */
/* .nav-item::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 1px;
  background-color: #1890ff;
  transition: width 0.3s;
} */
.nav-item:hover::after,
.nav-item.active::after {
  width: 100%; /* 悬停和激活时下划线宽度一致 */
}
.email-info {
  margin-top: 30px;
}
.email-content {
  font-size: 12px;
  color: #666;
  text-align: right;
  line-height: 1.6;
}
@media (max-width: 768px) {
  .top-nav {
    flex-direction: column;
    gap: 20px;
  }

  .nav-items {
    flex-wrap: wrap;
    justify-content: center;
    gap: 15px;
  }

  .email-content {
    text-align: center;
  }
}
</style>
<style scoped>
/* 移动端底部导航栏样式 */
.mobile-footer-navbar {
  background-color: white;
  padding: 20px;
  /* box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); */
}
.vertical-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.logo-section,
.nav-section,
.contact-section {
  text-align: left; /* 确保左对齐 */
}
.logo-container {
  margin-bottom: 10px;
}
.nav-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.nav-item {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  transition: all 0.3s;
  padding: 5px 0;
  position: relative;
  border-bottom: 2px solid transparent;
}
/* 悬停和激活状态统一效果 */
.nav-item:hover,
.nav-item.active {
  color: #0c80da !important;
  /* border-bottom-color: #0c80da !important; */
}
.contact-section {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.email-contentmobile {
  font-size: 12px;
  color: #666;
  line-height: 1.6;
}
/* 移动端样式优化 */
@media (max-width: 850px) {
  .cert-container {
    padding: 0 8px;
    overflow: hidden;
  }

  .icons-wrapper {
    width: 100%;
    position: relative;
  }

  .icons-track {
    width: calc(100% - 50px);
    margin: 0 10px;
    overflow: hidden;
  }

  /* 调整图标大小和间距，确保一行显示5个 */
  .cert-icon {
    width: 58px; /* 调整宽度确保完整显示 */
    height: 38px; /* 调整高度 */
    margin: 0 4px; /* 减小间距 */
    flex-shrink: 0;
  }
  .cert-icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .left_btn,
  .right_btn {
    font-size: 20px; /* 减小箭头大小 */
  }

  /* 确保轨道宽度适合5个图标 */
  .icons-track {
    max-width: 100%;
  }
}

/* 响应式调整 */
@media (max-width: 480px) {
  .cert-container {
    padding: 0 8px;
  }

  .icons-track {
    width: calc(100% - 40px); /* 进一步减小箭头区域 */
    margin: 0 8px;
  }

  .cert-icon {
    width: 52px; /* 进一步调整宽度 */
    height: 34px; /* 进一步调整高度 */
    margin: 0 3px; /* 进一步减小间距 */
  }

  .left_btn,
  .right_btn {
    font-size: 18px; /* 更小的箭头 */
  }
  .vertical-container {
    gap: 15px;
  }

  .nav-section {
    gap: 2px;
  }

  .nav-item {
    font-size: 14px;
    font-weight: bold;
  }

  .email-contentmobile {
    font-size: 12px;
  }
}
</style>
<style scoped>
@media (max-width: 800px) and (min-width: 501px) {
  .kongbai {
    display: none;
  }
}
/* 移动端三个白框样式 - 竖排排列，高度调整为26%，内部三行等分，内容左对齐 */
.mobile-contact-boxes {
  position: absolute;
  top: 7%; /* 调整为26% */
  left: 50%;
  transform: translate(-50%, 0);
  display: flex;
  flex-direction: column;
  width: 90%;
  gap: 15px;
  z-index: 10;
}

.mobile-contact-box {
  background: white;
  border-radius: 12px;
  padding: 0; /* 移除padding，让内部元素控制间距 */
  box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.1), 0 4px 12px rgba(0, 0, 0, 0.1);
  text-align: left; /* 改为左对齐 */
  border: 1px solid #e0e0e0;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  height: 110px; /* 固定高度确保三等分可见 */
  min-height: 110px;
}

/* 内部三行等分布局 - 左对齐 */
.mobile-box-icon,
.mobile-box-title,
.mobile-box-content {
  display: flex;
  align-items: center;
  justify-content: flex-start; /* 改为左对齐 */
  flex: 1; /* 三等分 */
  min-height: 30px; /* 确保最小高度 */
  padding-left: 20px; /* 添加左内边距 */
}

.mobile-box-icon {
  padding-top: 10px;
}

.mobile-box-icon img {
  width: 20px;
  /* height: 22px; */
}

.mobile-box-title {
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  padding: 0 20px; /* 左右都有内边距 */
}

.mobile-box-content {
  font-size: 14px;
  /* font-weight: 600; */
  word-wrap: break-word;
  line-height: 1.3;
  padding: 0 20px 10px; /* 左右内边距保持一致，底部有内边距 */
  display: flex;
  align-items: flex-start; /* 内容顶部对齐 */
  justify-content: flex-start; /* 左对齐 */
}

/* 移动端表单样式 - 位置特别往下200px */
.mobile-form-container {
  position: absolute;
  top: 44%; /* 使用固定像素值，特别往下200px */
  left: 50%;
  transform: translateX(-50%); /* 只水平居中，不垂直居中 */
  width: 90%;
  background: rgba(255, 255, 255, 0.91);
  border-radius: 12px;
  padding: 15px;
  box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.1), 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.mobile-form-header {
  position: absolute;
  top: 35%; /* 使用固定像素值，与表单保持适当距离 */
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 20px;
  color: #2c3e50;
}

.mobile-contact-form {
  display: flex;
  flex-direction: column;
}

.mobile-form-item {
  margin-bottom: 12px;
}

/* 移动端输入框样式 */
::v-deep.mobile-rounded-input .el-input__inner {
  border-radius: 10px !important;
  background-color: rgb(243, 243, 243) !important;
  border: 1px solid rgb(243, 243, 243) !important;
  padding: 12px 15px !important;
  width: 100% !important;
}

.mobile-full-width-select {
  width: 100% !important; /* 使用 !important 确保覆盖 */
  max-width: 100%; /* 防止超出父容器 */
  box-sizing: border-box; /* 重要的盒模型设置 */
}
::v-deep.mobile-full-width-select .el-input__inner {
  border-radius: 10px !important;
  background-color: rgb(243, 243, 243) !important;
  border: 1px solid rgb(243, 243, 243) !important;
  padding: 12px 15px !important;
  width: 100% !important;
}

/* 移动端文本域样式 */
::v-deep.mobile-message-textarea .el-textarea__inner {
  border-radius: 10px !important;
  background-color: rgb(243, 243, 243) !important;
  border: 1px solid rgb(243, 243, 243) !important;
  padding: 12px 15px !important;
  resize: none !important;
  min-height: 120px !important;
  font-family: inherit !important;
  line-height: 1.5 !important;
  width: 100% !important;
}

/* 移动端按钮样式 */
.mobile-gradient-button {
  padding: 12px 40px;
  border: none;
  border-radius: 50px;
  color: white;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
  background: linear-gradient(to right, #007bff, #28a745);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 40%;
}

.mobile-submit-button {
  margin-top: 30px;
  text-align: center;
}

/* 移动端标签样式 */
::v-deep.mobile-contact-form .el-form-item__label {
  text-align: left !important;
  display: block !important;
  width: 100% !important;
  padding-bottom: 8px !important;
  color: #2c3e50 !important;
  font-weight: normal !important;
  line-height: 25px !important;
  font-size: 14px !important;
}
@media (min-width: 480px) and (max-width: 850px) {
  .mobile-contact-boxes {
    width: 85%;
    gap: 12px;
    top: 12%; /* 保持26% */
  }
}

/* 响应式调整 */
@media (max-width: 480px) {
  .mobile-contact-boxes {
    width: 85%;
    gap: 12px;
    top: 9%; /* 保持26% */
  }

  .mobile-contact-box {
    height: 110px;
    min-height: 110px;
  }

  .mobile-box-icon img {
    width: 20px;
    /* height: 22px; */
  }

  .mobile-box-title {
    font-size: 15px;
    padding: 0 15px; /* 小屏幕调整内边距 */
  }

  .mobile-box-content {
    font-size: 14px;
    padding: 0 15px 8px; /* 小屏幕调整内边距 */
  }

  .mobile-form-container {
    width: 85%;
    padding: 20px 15px;
    top: 44%; /* 保持200px下移 */
  }

  .mobile-form-header {
    font-size: 20px;
    top: 35%; /* 保持固定位置 */
  }

  .mobile-gradient-button {
    padding: 10px 30px;
    font-size: 14px;
  }

  /* 调整左对齐的内边距 */
  .mobile-box-icon,
  .mobile-box-title,
  .mobile-box-content {
    padding-left: 15px; /* 小屏幕减少内边距 */
  }
}

/* 特别小的屏幕优化 */
@media (max-width: 360px) {
  .cert-icon {
    width: 45px;
    height: 30px;
    margin: 0 3px;
  }

  .icons-track {
    width: calc(100% - 35px);
  }
  .mobile-contact-box {
    height: 110px;
    min-height: 110px;
  }

  .mobile-box-icon {
    padding-top: 8px;
  }

  .mobile-box-icon img {
    width: 20px;
    /* height: 22px; */
  }

  .mobile-box-title {
    font-size: 14px;
    padding: 0 12px;
  }

  .mobile-box-content {
    font-size: 12px;
    padding: 0 12px 6px;
  }

  /* 调整左对齐的内边距 */
  .mobile-box-icon,
  .mobile-box-title,
  .mobile-box-content {
    padding-left: 12px; /* 特别小屏幕进一步减少内边距 */
  }

  .mobile-form-container {
    top: 44%; /* 特别小屏幕稍微调整位置 */
  }

  .mobile-form-header {
    top: 35%; /* 特别小屏幕稍微调整位置 */
  }
}

/* 中等屏幕优化 */
@media (min-width: 481px) and (max-width: 850px) {
  .mobile-form-container {
    top: 38%; /* 中等屏幕稍微增加下移距离 */
  }

  .mobile-form-header {
    top: 25%; /* 中等屏幕稍微增加下移距离 */
  }
}
</style>
<style scoped>
/* 确保轮播图内容在背景图上清晰可见 */
.creative-slide {
  position: relative;
  z-index: 2;
}

/* 添加半透明遮罩增强文字可读性 */
.background-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1;
}
</style>
